<script>

import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Editar Movimento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {DropZone, Layout, PageHeader, Loader, Multiselect},
  setup() {


    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    // return { dropzoneFile, drop};


    return { v$: useVuelidate(), dropzoneFile, drop };
  },
  data() {
    return {
      trackerMsgssData: null,

      totalCorreioServ: 0,
      pedidoSelecionado: null,

      showModalPrevEntr: false,
      submittedPrevEntr: false,

      bloqExibEconofrete: false,

      showModalLogRev: false,
      logistReverData: {},
      submittedLogRevTab1: false,
      submittedLogRevTab2: false,
      submittedLogRevTab3: false,
      activeTabLogRev: 0,
      loadingCnpjRemet: false,
      loadingCnpjDest: false,

      userLogged: {},

      freteCotaPrinc: null,
      dtListPesqFreteCota: null,
      dtListPesqCorreioServico: null,
      emprSegtoData: {},

      exibirNovaPlp: true,
      loadingMovPlp: false,
      movPlpsData: null,
      movPlpData: {
        'formato': '2',
        'layprint': 'LINEAR_100_150',
        'compinf': 1,
        'pesoinf': 1,
        'altuinf': 1,
        'larginf': 1,
        'prevpost': moment().format("YYYY-MM-DD")
      },
      movPlpsLoteData: null,

      submittedMovPlp: false,

      ocorrenciasData: null,
      showModalPLPCorreios: false,

      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasData: {},
      loadingFiles: false,

      loadingPedTipo: false,
      dtlistPesqPedTipo: null,
      showModalPedTipo: false,
      pedTipoData: {},

      showModalPesoManual: false,
      submmitedPesoManual: false,
      pesoAcotar: 0,

      showModalCotarFreteInterno: false,

      showModalCotarFrete: false,
      loadingCotarFrete: false,
      cotaFreteListData: {},
      cotaFreteInternoListData: {},


      wmsOssData: null,
      movItensData: {},
      mocCtesData: null,
      empresaData: {},
      dtListPesqEntrega: null,
      entregaData: null,

      dtListPesqOrigem: null,
      dtListPesqDestino: null,
      origemData: {},
      destinoData: {},


      dtListPesqReceb: null,
      recebedorData: null,
      dtListPesqExpedidor: null,
      expedidorData: null,
      dtListPesqDestinatario: null,
      destinatarioData: null,
      transpData: {},
      dtListPesqEmit: null,
      emitenteData: null,


      dtListPesqCidadeOrigem: null,
      cidadeData: {},


      dataBaixa: new Date(),
      showModalBaixaParc: false,
      vlrTotalParcs: 0,
      regSelFinParc: {},
      showModalFinanParc: false,

      finanBoletoData: null,
      mediaBase64Data: null,
      dtListPesqFinConta: null,
      finContaData: null,
      priVencto: moment(new Date()).format('YYYY-MM-DD'),
      intervParcelas: 30,
      qtdParcelas: 1,
      dtListPesqCli: null,

      loadingCFOPs: false,
      submitMov: false,
      submitFinanParc: false,
      finanparcData: {},
      loadingFinanceiro: false,
      dtListPesqCFOP: null,
      dtListPesqProduto: null,
      showModalParcela: false,
      errosValid: null,
      contClickAvanc: 0,

      movData: {
        id: 0,
        status: 'EL',
        //stsbaixa: 'AB',
        tipo: "NO",
        tiposrv: "NO",
        dtemissao: moment(new Date()).format('YYYY-MM-DD'),
        dtentrega: moment(new Date()).format('YYYY-MM-DD'),
        compet: moment(new Date()).format('YYYY-MM-DD'),


      },

      finanParcsData: null,
      enderecosData: {},
      idData: 0,
      updating: true,
      activeTab: 0,
      submitted: false,

      title: "Editar Movimento",
      items: [
        {
          text: "Movimentos",
          href: "/movimentos/listnova",
        },
        {
          text: "Editar Movimento",
          active: true,
        },
      ],
    };
  },
  validations: {
    movData: {
      pessoa: {
        required: helpers.withMessage("Campo fornecedor obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo Código obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo Número obrigatório, favor preencher.", required),
      },
      dtemissao: {
        required: helpers.withMessage("Campo Data de emissão obrigatório, favor preencher.", required),
      },
      vencimento: {
        required: helpers.withMessage("Campo Data de vencimento obrigatório, favor preencher.", required),
      },
      valor: {
        required: helpers.withMessage("Campo Valor deve ser maior que zero, favor preencher.", required),
      },
    },
    finanparcData: {
      cfop: {
        required: helpers.withMessage("Campo CFOP obrigatório, favor preencher.", required),
      },
    }
  },

  created() {

    if (window.location.href.includes('lelloprint')
        || window.location.href.includes('bluevix')
        || window.location.href.includes('belfar')
        || window.location.href.includes('creative')) {
      this.bloqExibEconofrete = true
    }

  },

  methods: {
    desconsiderarFluxoSaldoItem(data){
      console.log('desconsiderarFluxoSaldoItem')
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Deseja realmente desativar o fluxo do movimentação(saldo) do item atual?",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      }).then((resposta) => {
        if(resposta.isConfirmed){
          api.post(`${getBaseUrl()}api/movitemdesconsidsaldo`, {
            movitem: data
          }).then((res) => {
            console.log('then axios movitemdesconsidsaldo')
            console.log(res.data)

            Swal.fire({
              position: "top-end",
              icon: res.data.success ? "success" : "error",
              title: res.data.message,
              showConfirmButton: false,
              timer: 2500
            })

            this.carregarDados()
          })
        }else{
          return
        }
      })
    },

    confProvEntr(){
      console.log('confProvEntr')
      this.submittedPrevEntr = true
      if (this.movData.dtpreventrep){
        this.showModalPrevEntr = false
        api.post(`${getBaseUrl()}api/mov`, {
          movData: this.movData
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.carregarDados()

        })
      }
    },


    novaPrevEntr(){
      console.log('novaPrevEntr')
      this.showModalPrevEntr = true


    },


    consultarCNPJRem(){
      console.log('consultarCNPJRem')
      console.log(this.logistReverData)
      this.loadingCnpjRemet = true
      api.get(`${getBaseUrl()}api/clicnpj`, {
        params: { cnpjdata: this.logistReverData.remetcnpj }
      }).then((res) => {
        console.log('then axios_cli_cnpj')
        console.log(res.data)
        if (res.data[0]){
          console.log('bunda')
          this.logistReverData.remetnome = res.data[0].nome
          this.logistReverData.remetcep = res.data[0].cep
          this.logistReverData.remetbairro = res.data[0].bairro
          this.logistReverData.remetrua = res.data[0].rua
          this.logistReverData.remetnum = res.data[0].numero
          this.logistReverData.remetestado = res.data[0].estado
          this.logistReverData.remetcidade = res.data[0].cidade
          this.logistReverData.remetcompl = res.data[0].compl
          this.logistReverData.remetmail = res.data[0].email
        }
        this.loadingCnpjRemet = false
      })
    },

    consultarCNPJDest(){
      console.log('consultarCNPJDest')
      console.log(this.logistReverData)
      this.loadingCnpjDest = true
      api.get(`${getBaseUrl()}api/clicnpj`, {
        params: { cnpjdata: this.logistReverData.destcnpj }
      }).then((res) => {
        console.log('then axios_cli_cnpj')
        console.log(res.data)
        if (res.data[0]){

          this.logistReverData.destnome = res.data[0].nome
          this.logistReverData.destcep = res.data[0].cep
          this.logistReverData.destbairro = res.data[0].bairro
          this.logistReverData.destrua = res.data[0].rua
          this.logistReverData.destnum = res.data[0].numero
          this.logistReverData.destestado = res.data[0].estado
          this.logistReverData.destcidade = res.data[0].cidade
          this.logistReverData.destcompl = res.data[0].compl
          this.logistReverData.destmail = res.data[0].email
        }
        this.loadingCnpjDest = false
      })
    },


    consultarCEPRem() {
      console.log('consultarCEPRem')
      const cepTratado = this.logistReverData.remetcep.replaceAll('.','').replaceAll('-','')
      this.loadingCnpjRemet = true
      api.get(`${getBaseUrl()}api/conscep`, {
        params: { cep: cepTratado }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        const dataCep = res.data[0]
        this.logistReverData.remetrua = dataCep.logradouro
        this.logistReverData.remetcompl = dataCep.complemento
        this.logistReverData.remetbairro = dataCep.bairro
        this.logistReverData.remetcidade = dataCep.localidade
        this.logistReverData.remetestado = dataCep.uf
        this.loadingCnpjRemet = false
      })
    },


    consultarCEPDest() {
      console.log('consultarCEPDest')
      const cepTratado = this.logistReverData.destcep.replaceAll('.','').replaceAll('-','')
      this.loadingCnpjDest = true
      api.get(`${getBaseUrl()}api/conscep`, {
        params: { cep: cepTratado }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        const dataCep = res.data[0]
        this.logistReverData.destrua = dataCep.logradouro
        this.logistReverData.destcompl = dataCep.complemento
        this.logistReverData.destbairro = dataCep.bairro
        this.logistReverData.destcidade = dataCep.localidade
        this.logistReverData.destestado = dataCep.uf
        this.loadingCnpjDest = false
      })
    },


    abrirLogReversa(){
      console.log('abrirLogReversa')

      let dddrem = ''
      let telrem = ''
      if (this.destinatarioData.tel1) {
        dddrem = this.destinatarioData.tel1.substring(0, 2)
        telrem = this.destinatarioData.tel1.substring(2, 10)
      }
      this.logistReverData.remetcnpj = this.destinatarioData.cnpj
      this.logistReverData.remetnome = this.destinatarioData.nome
      this.logistReverData.remetrua = this.destinatarioData.rua
      this.logistReverData.remetnum = this.destinatarioData.numero
      this.logistReverData.remetcompl = this.destinatarioData.compl
      this.logistReverData.remetbairro = this.destinatarioData.bairro
      this.logistReverData.remetestado = this.destinatarioData.estado
      this.logistReverData.remetcidade = this.destinatarioData.cidade
      this.logistReverData.remetcep = this.destinatarioData.cep
      this.logistReverData.remetddd = dddrem
      this.logistReverData.remettel = telrem
      this.logistReverData.remetmail = ''

      let ddddest = ''
      let teldest = ''
      if (this.emitenteData.tel1) {
        ddddest = this.emitenteData.tel1.substring(0, 2)
        teldest = this.emitenteData.tel1.substring(2, 10)
      }
      this.logistReverData.destcnpj = this.emitenteData.cnpj
      this.logistReverData.destnome = this.emitenteData.nome
      this.logistReverData.destrua = this.emitenteData.rua
      this.logistReverData.destnum = this.emitenteData.numero
      this.logistReverData.destcompl = this.emitenteData.compl
      this.logistReverData.destbairro = this.emitenteData.bairro
      this.logistReverData.destestado = this.emitenteData.estado
      this.logistReverData.destcidade = this.emitenteData.cidade
      this.logistReverData.destcep = this.emitenteData.cep
      this.logistReverData.destddd = ddddest
      this.logistReverData.desttel = teldest
      this.logistReverData.destmail = this.emitenteData.email

      this.logistReverData.vols = this.movData.qtdvol
      this.logistReverData.prod1 = this.movData.codigo || ''

      this.showModalLogRev = true

    },


    confTab1LogRev(){
      console.log('confTab1LogRev')
      this.submittedLogRevTab1 = true
      if (this.logistReverData.codserv && this.logistReverData.tipo
          && this.logistReverData.prod1 && this.logistReverData.aglimcol){
        this.activeTabLogRev = 1
      }
    },

    confTab2LogRev(){
      console.log('confTab2LogRev')
      if (!this.logistReverData.codserv || !this.logistReverData.tipo
          || !this.logistReverData.prod1 || !this.logistReverData.aglimcol){
        this.submittedLogRevTab1 = true
        this.activeTabLogRev = 0
      } else {
        this.submittedLogRevTab2 = true
        if (this.logistReverData.codserv && this.logistReverData.remetnome
            && this.logistReverData.remetcep && this.logistReverData.remetbairro
            && this.logistReverData.remetrua && this.logistReverData.remetnum
            && this.logistReverData.remetestado && this.logistReverData.remetcidade) {
          this.activeTabLogRev = 2
        }
      }
    },

    confTab3LogRev(){
      console.log('confTab3LogRev')
      if (!this.logistReverData.codserv || !this.logistReverData.tipo
          || !this.logistReverData.prod1 || !this.logistReverData.aglimcol){
        this.submittedLogRevTab1 = true
        this.activeTabLogRev = 0
      } else if (!this.logistReverData.remetcnpj || !this.logistReverData.remetnome
          || !this.logistReverData.remetcep || !this.logistReverData.remetbairro
          || !this.logistReverData.remetrua || !this.logistReverData.remetnum
          || !this.logistReverData.remetestado || !this.logistReverData.remetcidade) {
        this.submittedLogRevTab2 = true
        this.activeTabLogRev = 1
      } else {
        this.submittedLogRevTab3 = true
        if (this.logistReverData.destnome && this.logistReverData.destcep && this.logistReverData.destbairro
            && this.logistReverData.destrua && this.logistReverData.destnum && this.logistReverData.destestado
            && this.logistReverData.destcidade) {
          this.showModalLogRev = false
          api.post(`${getBaseUrl()}api/movcorlogrev`, {
            idData: this.idData,
            solicitarAuto: true,
            correioLogRevData: this.logistReverData
          }).then(() => {
            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Solicitação de logística reversa enviada com sucesso!",
              showConfirmButton: false,
              timer: 2500
            })
            this.$router.push('/fretes/logreversa')
          }).catch(() => {
            this.updating = false
            Swal.fire({
              position: "top-end",
              icon: "error",
              title: "Erro ao enviar solicitação de logística reversa, favor tentar novamente mais tarde!",
              showConfirmButton: false,
              timer: 3500
            })
          })
        }
      }
    },


    pesqFreteCotaEmpr(evt) {
      console.log('pesqFreteCotaEmpr')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        // this.loadingTransp = true
        this.empresaData.transp = ''
        api.get(`${getBaseUrl()}api/pesqfretecotaempr`, {
          params: {q: query, e: this.movData.empresa}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFreteCota = res.data
        })
      }
    },

    escolheuFreteCota() {
      console.log('escolheuFreteCota')
      //this.loadingTransp = true
      console.log(this.empresaData.segto)
      api.get(`${getBaseUrl()}api/fretecotacod`, {
        params: {coddata: this.empresaData.segto}
      }).then((res) => {
        console.log('then axios_escolheu_fretecota')
        console.log(res.data)
        this.freteCotaData = res.data[0]
        //this.loadingTransp = false
      })
    },

    integerOnly(event) {
      event.target.value = Math.floor(event.target.value);
    },

    pesqCorreioServico(evt){
      console.log('pesqCorreioServico')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.loadingTransp = true
        api.get(`${getBaseUrl()}api/corservpesq`, {
          params: { q: query, emp: this.movData.empresa }
        }).then((res) => {
          console.log('then axios')
          // console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCorreioServico = res.data
        })
      }
    },

    solicitarRotuloLote(idLote, layout){
      console.log('solicitarRotulo')
      
      Swal.fire({
        position: "center",
        icon: "info",
        title: 'Estamos solicitando o seu rótulo(etiqueta)',
        showConfirmButton: false,
        timer: 2000
      })

      this.loadingMovPlp = true
      if (idLote) {
        api.get(`${getBaseUrl()}api/movplprotu`, {
          params: {
            'iddata': idLote,
            'layout': layout
          }
        }).then((res) => {
          console.log('then axios rotular plp')
          console.log(res.data)

          this.loadingMovPlp = false
          this.movPlpsData = res.data[0]

          const rowData = this.movPlpsData[0]
          console.log('rowData: ' , rowData)

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'O rótulo foi solicitado com sucesso',
            showConfirmButton: false,
            timer: 1500
          })

          this.solicitarRotulo(rowData)
        })
      }
    },

    solicitarRotulo(rowData) {
      console.log('solicitarRotulo')
      // console.log(rowData.id)

      this.loadingMovPlp = true
      if (rowData.recibo) {
        api.get(`${getBaseUrl()}api/movplprotuimpr`, {
          params: {
            'iddata': rowData.id
          }
        }).then((res) => {
          console.log('then axios rotular plp')
          // console.log(res.data)
          this.loadingMovPlp = false
          if(res.data[0] === 'erro') {

            Swal.fire({
              position: "top-end",
              icon: "error",
              title: res.data[1],
              showConfirmButton: false,
              timer: 3500
            })
          } else {
            console.log('res.data')
            console.log(res.data)
            const b64 = (res.data && res.data.base64) ? res.data.base64 : res.data;
            if (res.data && res.data.has_etiqueta) {
              rowData.has_etiqueta = true;
            }
            const byteChars = atob(b64);
            const byteNums = new Array(byteChars.length);
            for (let i = 0; i < byteChars.length; i++) {
              byteNums[i] = byteChars.charCodeAt(i);
            }
            const blob = new Blob([new Uint8Array(byteNums)], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            const printWin = window.open(blobUrl, '_blank');
            if (printWin) {
              printWin.addEventListener('load', () => {
                const style = printWin.document.createElement('style');
                style.textContent = '@page { size: 100mm 150mm; margin: 0; } body { margin: 0; }';
                printWin.document.head.appendChild(style);
                printWin.print();
                setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
              });
            }
          }

          this.showModalPLPCorreios = false
        })
      } else {
        api.get(`${getBaseUrl()}api/movplprotu`, {
          params: {
            'iddata': rowData.id
          }
        }).then((res) => {
          console.log('then axios rotular plp')
          // console.log(res.data)
          this.loadingMovPlp = false
          this.movPlpsData = res.data[0]
          const freshRow = this.movPlpsData.find(p => p.id === rowData.id) || rowData
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: 'O rótulo foi solicitado com sucesso',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            Swal.fire({
              position: "center",
              icon: "info",
              title: 'Re-executamos seu processo de etiqueta e iremos tentar imprimir novamente a etiqueta!',
              showConfirmButton: true,
              confirmButtonText: "Sim",
              showCancelButton: true,
              cancelButtonText: "Não",
            }).then((regerarLote) => {
              if (regerarLote.value) {
                this.solicitarRotulo(freshRow)
              }
            })
          })
        })
      }
    },


    cancelarMovPlp(idData) {
      console.log('cancelarMovPlp')
      console.log(idData)

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de PLP",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar Cancelamento",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          //this.$emit('deletareg', idData)
          this.loadingMovPlp = true

          api.get(`${getBaseUrl()}api/movplpcanc`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios cancelar plp')
            console.log(res.data)
            this.loadingMovPlp = false
            this.movPlpsData = res.data[0]
            const success = res.data[1]
            const msg = res.data[2]

            this.exibirNovaPlp = true
            this.movPlpsData.forEach((movPlp) => {
              if (movPlp.status !== '5') {
                this.exibirNovaPlp = false
              }
            })

            if(success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: msg,
                showConfirmButton: false,
                timer: 1500
              })
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: msg,
                showConfirmButton: true
              })
            }
          })


        }
      })

    },


    async confPLPCorreios() {
      console.log('confPLPCorreios');
      this.exibirNovaPlp = false;
      this.submittedMovPlp = true;

      const { formato, servico, compinf, pesoinf, altuinf, larginf } = this.movPlpData;
      
      if (!formato || !servico || !compinf || !pesoinf || !altuinf || !larginf) {
        return;
      }

      console.log('lote data')
      console.log(this.movPlpsLoteData)

      this.loadingMovPlp = true;

      try {
        const res = await api.post(`${getBaseUrl()}api/movsplpcorreios`, {
          idsData: [this.idData],
          movPlpLoteData: this.movPlpData,
          loteData: this.movPlpsLoteData ?? null
        });

        console.log('Resposta axios:', res);

        if (res.data[0] === 'erro') {
          throw new Error(res.data[1]);
        }

        this.movPlpsLoteData = res.data[0];
        this.movPlpsData = res.data[1];
        this.exibirNovaPlp = false;
        
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: 'O registro foi criado com sucesso',
          showConfirmButton: false,
          timer: 2500
        }).then(() => {
          Swal.fire({
            position: "center",
            icon: "info",
            title: 'Aguarde um pouquinho, já iremos validar o lote criado!',
            text: "Se possível não saida dessa tela",
            showConfirmButton: false,
            timer: 3000
          })
        })

        await this.sleep(8000);

        const resCons = await api.get(`${getBaseUrl()}api/movsplpcorreioscons`, {
          params: {
            'idlote': this.movPlpsLoteData.idlote
          }
        });

        console.log('Resposta consulta:', resCons.data[0]);

        if (resCons.data[0] === 'erro') {
          const msgErroConsulta = resCons.data[1] || '';
          const ehErroCep = /CEP[-\s]?\d{3}|PPN[-\s]?202|CEP.*não foi encontrado|não foi encontrado.*CEP/i.test(msgErroConsulta);

          if (ehErroCep) {
            if (this.movPlpsLoteData && this.movPlpsLoteData.id) {
              await api.get(`${getBaseUrl()}api/movplplotedel`, {
                params: { id: this.movPlpsLoteData.id }
              }).catch(() => {});
              this.carregarDados();
            }

            this.loadingMovPlp = false;
            this.exibirNovaPlp = true;
            this.movPlpsLoteData = null;

            const { isConfirmed } = await Swal.fire({
              position: 'center',
              icon: 'error',
              title: 'CEP inválido para os Correios',
              html: `<p>O endereço do destinatário possui um CEP não reconhecido pelo sistema de <strong>Pré-Postagem (PPN)</strong> dos Correios:</p><strong>${msgErroConsulta}</strong><p class="mt-2">Deseja abrir o cadastro do cliente para corrigir o endereço?</p>`,
              showConfirmButton: true,
              showDenyButton: true,
              confirmButtonText: 'Abrir cadastro do cliente',
              denyButtonText: 'Cancelar',
            });

            if (isConfirmed && this.destinatarioData && this.destinatarioData.id) {
              const routeData = this.$router.resolve(`/cliente/editar/${this.destinatarioData.id}`);
              window.open(routeData.href, '_blank');
            }
            return;
          }

          const aceitou = await this.aceitePLP();

          if (aceitou) {
            console.log('Usuário aceitou, tentando novamente...');
            return await this.confPLPCorreios();
          } else {
            this.exibirNovaPlp = true;
            this.movPlpsLoteData = null;
            return;
          }
        }

        if (this.movPlpsData && this.movPlpsData) {
          this.movPlpsData.forEach((movPlp) => {
            this.solicitarRotuloLote(movPlp.id, movPlp.layprint);
          })
          this.loadingMovPlp = false;
          this.carregarDados()
        }

      } catch (err) {
        console.error('Erro no processo:', err);
        this.loadingMovPlp = false;
        
        // Tratamento de erro unificado (serve para o throw new Error acima e erros de rede)
        const msgErro = err.message || err; // Caso o erro venha como objeto ou string
        this.exibirNovaPlp = true;
        this.movPlpsLoteData = null;
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: 'Erro na execução do processo',
          text: msgErro,
          showConfirmButton: false,
          timer: 3500
        });
      }
    },

    async aceitePLP() {
      console.log('aceitePLP')

      const result = await Swal.fire({
        position: "center",
        icon: "info",
        title: 'Aceite necessário!',
        html: `
        <h4>Cláusula de Aceite e Responsabilidade:</h4>
        <h5>Ao prosseguir com a contratação deste serviço, o usuário declara estar ciente de que, caso o valor do bem ou serviço contratado ultrapasse o limite máximo ou seja inferior ao limite mínimo estabelecido 
          pela política vigente, toda e qualquer consequência financeira, incluindo eventuais prejuízos, perdas ou ônus decorrentes da operação, será de inteira responsabilidade do contratante que realizou o aceite, 
          isentando a contratada de qualquer obrigação ou ressarcimento.</h5>
        `,
        input: 'text',
        inputLabel: 'Nome e Sobrenome',
        showConfirmButton: true,
        showDenyButton: true,
        confirmButtonText: 'Confirmar',
        denyButtonText: `Cancelar`,
        didOpen: () => {
          const container = Swal.getContainer();
          if (container) {
             container.addEventListener('focusin', (e) => {
                 e.stopPropagation();
             });
          }
        },
        inputPlaceholder: 'Ex: Maria Silva',
        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return 'Digite seu nome e sobrenome completos para confirmar.';
          }

          const normalizado = value.trim().toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '');

          const bloqueados = [
            'nao autorizado', 'sem autorizacao', 'sem autorizacao',
            'nao autorizei', 'sem autorizacao',
            'atacado sp', 'atacado sao paulo', 'atacadosaopaulo',
            'admin', 'administrador', 'sistema', 'user', 'usuario',
            'teste', 'test', 'fulano', 'ciclano', 'beltrano',
            'nao', 'sim', 'ok', 'cancelar', 'confirmar',
          ];

          if (bloqueados.some(b => normalizado.includes(b))) {
            return 'Nome inválido. Digite seu nome e sobrenome reais para assinar a cláusula de responsabilidade.';
          }

          const palavras = value.trim().split(/\s+/);
          if (palavras.length < 2) {
            return 'Digite nome e sobrenome (pelo menos duas palavras).';
          }

          const todasLetras = palavras.every(p => /^[a-zA-ZÀ-ÿ\-']+$/.test(p));
          if (!todasLetras) {
            return 'O nome deve conter apenas letras, sem números ou símbolos.';
          }

          const minimoCaracteres = palavras.every(p => p.length >= 2);
          if (!minimoCaracteres) {
            return 'Cada parte do nome deve ter pelo menos 2 caracteres.';
          }
        }
      })

      // console.log('aceitePLP')
      // console.log(result)

      if(result.isConfirmed) {
        this.movPlpsLoteData.nomeaceite = result.value
        this.movPlpsLoteData.dataaceite = new Date()
        return true
      } else {
        return false
      }
    },

    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms)
      })
    },

    plpCorreios() {
      console.log('plpCorreios')
      console.log(this.totalCorreioServ)
      if (this.totalCorreioServ > 0) {

        this.pedidoSelecionado = this.movData.codigo;

        if(this.transpData){
          if (this.transpData.apirastreio !== 'CORREIOS') {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Transportador atual não possui serviço Correios.",
              showConfirmButton: false,
              timer: 4500
            })

          } else {
            this.showModalPLPCorreios = true
          }
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Nota Fiscal sem Transportador.",
            showConfirmButton: false,
            timer: 3000
          })
        }


      } else {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nenhum serviço disponível para Correios, favor validar o token em Administrativo - Empresas - Tokens - Correios - Validar Token.",
          showConfirmButton: false,
          timer: 4500
        })

      }
    },


    downFile(path, nomeArq) {
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())
      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: {pathData: path}
      }).then((res) => {
        console.log('res down')
        console.log(res.data)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);
        console.log('fileLink')
        console.log(fileURL)
        fileLink.click();
        this.loadingFiles = false
      })
    },


    delFile(dataID) {
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.loadingFiles = true
          api.delete(`${getBaseUrl()}api/media`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.loadingFiles = false
            this.mediasData = res.data[0]
          })
        }
      })
    },

    novoAnexo() {
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },


    confAnexo() {
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name) {
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/movfileanexo`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasData = res.data[0]
          this.loadingFiles = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },

    selectedFile() {
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

    },


    efetivarOperacao() {
      console.log('efetivarOperacao')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Efetivação de Movimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true

          api.post(`${getBaseUrl()}api/movefet`, {
            idData: this.idData,
            tipo: this.movData.tipo
          }).then((res) => {
            console.log('then axios movefet')
            console.log(res.data)
            //console.log(JSON.stringify(res.data))

            this.updating = false
            this.movData.status = 'TRA'

            let success = res.data.success
            let message = res.data.message
            let error = res.data.error ?? null
            let destino = res.data.destino
            let destino_id = res.data.destino_id

            if(success){
              Swal.fire({
                position: "center",
                icon: "success",
                title: message,
                text: "Deseja redirecionar para movimento gerado?",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: "Sim",
                cancelButtonText: "Não",
              }).then((confirm) => {
                if(confirm.isConfirmed){
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: 'Direcionando para movimento criado!',
                    showConfirmButton: false,
                    timer: 1500
                  }).then(() => {
                    //Verificando url para destino
                    switch(destino){
                      case 'monitoramentoCompra':
                        console.log('redirecionando para monitoramentoCompra')
                        this.$router.replace({name: "CompraImpXML", params: {id: 0}, query: {dadosNotaImportacao: JSON.stringify(res.data.dadosNota)}})
                        break
                      case 'Compra':
                        this.$router.replace(`/movcompra/editar/${destino_id}`)
                        break
                      case 'Devolução':
                        this.$router.replace(`/movdevol/editar/${destino_id}`)
                        break
                      case 'Orçamento':
                        this.$router.replace(`/orcamento/editar/${destino_id}`)
                        break
                      case 'Ajuste':
                        this.$router.replace(`/movajuste/editar/${destino_id}`)
                        break
                    }
                  })
                }
              })
            }else{
                Swal.fire({
                position: "top-end",
                icon: "error",
                title: error,
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })
    },


    escolheuPedTipo() {
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.movData.tipo)

      api.post(`${getBaseUrl()}api/movtipo`, {
        idData: this.idData,
        tipo: this.movData.tipo
      }).then((res) => {
        console.log('then axios')
        console.log(res)

      })

    },

    pesqPedTipo(evt) {
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.movData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: {q: query, f: this.movData.empresa}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },


    confPesoManual() {
      console.log('confPesoManual')
      this.submmitedPesoManual = true

      if (this.movData.pesomanual && this.movData.dimemanual) {
        this.showModalPesoManual = false
        this.cotarFrete()
      }
    },


    cotarFrete() {
      console.log('cotarFrete')

      let pesoCtes = 0.00

      let pesoITens = 0.00
      let pesoMov = 0.00
      let pesoManual = 0.00
      let dimeManual = 0.00

      if (this.movItensData) {
        this.movItensData.forEach((itemov) => {
          pesoITens += itemov.peso
        })
      }

      if (this.mocCtesData) {
        this.mocCtesData.forEach((movcte) => {
          pesoCtes += movcte.peso
        })
      }

      // pesoMovLiq = this.movData.pesoliq
      // pesoMovBrt = this.movData.pesoliq

      if (this.movData.pesoliq > this.movData.pesobrt) {
        pesoMov = this.movData.pesoliq
      }

      if (this.movData.pesoliq < this.movData.pesobrt) {
        pesoMov = this.movData.pesobrt
      }

      if (this.movData.pesomanual) {
        pesoManual = this.movData.pesomanual
      }

      if (this.movData.dimemanual) {
        dimeManual = this.movData.dimemanual
      }

      console.log('dimeManual', dimeManual)
      console.log('pesoITens', pesoITens)
      console.log('pesoCtes', pesoCtes)
      console.log('pesoMov', pesoMov)
      console.log('pesoManual', pesoManual)


      if (!pesoManual || pesoManual === 0) {
        if (pesoCtes > 0.00) {
          this.movData.pesomanual = pesoCtes
        } else if (pesoITens > 0.00) {
          this.movData.pesomanual = pesoITens
        } else if (pesoMov > 0.00) {
          this.movData.pesomanual = pesoMov
        }
      }

      if (!dimeManual || dimeManual === 0) {
        this.movData.dimemanual = 0.0034
      }


      if ((dimeManual === 0.00) ||
          (pesoITens === 0.00 && pesoCtes === 0.00 && pesoMov === 0.00 && pesoManual === 0.00)) {

        this.showModalPesoManual = true

      } else {

        this.showModalCotarFrete = true
        this.loadingCotarFrete = true

        if (pesoCtes > 0.00) {
          this.pesoAcotar = pesoCtes
        } else if (pesoITens > 0.00) {
          this.pesoAcotar = pesoITens
        } else if (pesoMov > 0.00) {
          this.pesoAcotar = pesoMov
        } else if (pesoManual > 0.00) {
          this.pesoAcotar = pesoManual
        }


        api.get(`${getBaseUrl()}api/cotarfretemov`, {
          params: {
            iddata: this.idData,
            peso: this.pesoAcotar,
            pesomanual: this.movData.pesomanual,
            dimemanual: this.movData.dimemanual,
            seguimento: this.emprSegtoData.codigo
          }
        }).then((res) => {
          console.log('res cotarFrete')
          console.log(res.data)
          if (res.data['SDT_WSRetorno']['Messages']) {
            console.log('existe erro')
            let erros = res.data['SDT_WSRetorno']['Messages']
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            erros.forEach((erro) => {
              listaErros.push({
                'titulo': erro['Description'],
                'mensagem': erro['Type']
              })
            })
            this.errosValid = listaErros
            this.showModalCotarFrete = false
          } else if (res.data['SDT_WSRetorno']['Resultados']) {
            console.log('existe resultado')

            // console.log(res.data['SDT_WSRetorno']['Resultados'])
            this.cotaFreteListData = res.data['SDT_WSRetorno']['Resultados']
            // ordenar array pela WSOut_Frete_Val
            this.cotaFreteListData = this.cotaFreteListData.slice().sort(function (a, b) {
              return a.WSOut_Frete_Val - b.WSOut_Frete_Val;
            })

            let menorValor = 999999
            let menorPrazo = 999999
            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val < menorValor) {
                menorValor = value.WSOut_Frete_Val
              }
              if (value.WSOut_Prazo_Dias < menorPrazo) {
                menorPrazo = value.WSOut_Prazo_Dias
              }

              value.WSOut_Frete_Val = parseFloat(value.WSOut_Frete_Val)


            })

            this.cotaFreteListData.forEach((value) => {
              if (value.WSOut_Frete_Val === menorValor) {
                value['menorvalor'] = true
              }
              if (value.WSOut_Prazo_Dias === menorPrazo) {
                value['menorprazo'] = true
              }
            })
            this.loadingCotarFrete = false

          }
        })
      }
    },


    cotarFreteInterno() {
      console.log('cotarFreteInterno')

      // cotação modal em tela
      // this.showModalCotarFreteInterno = true
      // this.loadingCotarFrete = true
      //   api.get(`${getBaseUrl()}api/cotarfreteintmov`, {
      //     params: {
      //       iddata: this.idData
      //     }
      //   }).then((res) => {
      //     console.log('res cotarFrete')
      //     console.log(res.data)
      //     this.cotaFreteInternoListData = res.data[0]
      //     this.loadingCotarFrete = false
      //   })

      // cotação nova view TESTES
      const routeData = this.$router.resolve(`/movimento/cotarinterno/${this.idData}`)
      window.open(routeData.href, '_blank')

    },


    abrirCte(movCte) {
      console.log('abrirCte')
      console.log(movCte)

      const routeData = this.$router.resolve(`/movcte/editar/${movCte}`)
      window.open(routeData.href, '_blank')

    },

    rastreamento() {
      console.log('rastreamento')
      const routeData = this.$router.resolve(`/tracking/detalhe/${this.idData}`)
      window.open(routeData.href, '_blank')


    },

    imprimirDanfe() {
      // envia um array cujo único elemento é o id da movimentação
      const movId = this.idData || this.movData.id
      if (!movId || movId === 0) {
        Swal.fire('Aviso', 'ID da movimentação inválido.', 'warning')
        return
      }
      const payload = {
        listItens: [movId]
      }
      console.log('Enviando payload:', payload)

      // espera um binário (zip) como resposta
      api.post(`${getBaseUrl()}api/movGeraDanfe`, payload, { responseType: 'blob' })
        .then((res) => {
          console.log('Resposta enviar-ids (blob):', res)

          // tentar interpretar possíveis erros retornados como JSON dentro do blob
          const contentType = res.headers['content-type'] || ''

          if (contentType.includes('application/json')) {
            // é um JSON (provavelmente erro) -> ler e mostrar mensagem
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const text = reader.result
                const obj = JSON.parse(text)
                const msg = obj.message || obj.msg || JSON.stringify(obj)
                Swal.fire('Erro', msg, 'error')
              } catch (e) {
                Swal.fire('Erro', 'Resposta inválida do servidor.', 'error')
              }
            }
            reader.readAsText(res.data)
            return
          }

          // se não for JSON, assume-se binário para download
          const disposition = res.headers['content-disposition'] || res.headers['Content-Disposition'] || ''
          let filename = `danfe_${movId}.zip`
          const fileNameMatch = disposition.match(/filename\*?=([^;\n]+)/i)
          if (fileNameMatch) {
            filename = fileNameMatch[1].replace(/UTF-8''/i, '').replace(/"/g, '').trim()
          }

          const blob = new Blob([res.data], { type: contentType || 'application/zip' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)

          Swal.fire('Sucesso', 'Download iniciado.', 'success')
        })
        .catch((err) => {
          console.error('Erro ao gerar/baixar DANFE:', err)
          let msg = 'Erro ao gerar/baixar DANFE.'
          // tentar extrair mensagem quando houver resposta com json
          if (err && err.response && err.response.data) {
            try {
              // se responseType foi blob, ler como texto
              const reader = new FileReader()
              reader.onload = () => {
                try {
                  const obj = JSON.parse(reader.result)
                  msg = obj.message || obj.msg || msg
                } catch (e) {
                  // noop
                }
                Swal.fire('Erro', msg, 'error')
              }
              reader.readAsText(err.response.data)
              return
            } catch (e) {
              // noop
            }
          }
          Swal.fire('Erro', msg, 'error')
        })
    },


    abrirOSSep(wmsOsID) {
      console.log('abrirOSSep')

      const routeData = this.$router.resolve(`/wmsos/saidaeditarnova/${wmsOsID}`)
      window.open(routeData.href, '_blank')

    },

    // importarXML() {
    //   console.log('importarXML')
    //   this.$router.push(`/mov/importar/0`)
    //
    //    /wmsos/saidaeditarnova/
    //
    //
    // },


    confirmar() {
      console.log('confirmar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Confirmação de Movimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.post(`${getBaseUrl()}api/movconf`, {
            iddata: this.idData
          }).then((res) => {

            console.log('then axios')
            console.log(res.data[0])

            // this.wmsOssData = res.data[1]

            if (res.data[0] === 'erro_conf_orcto') {
              this.updating = false

              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Erro ao Confirmar Movimento",
                text: res.data[1],
                showConfirmButton: false,
                timer: 4500
              })

            } else {
              this.movData.status = 'PR'
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento confirmado com sucesso",
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })

    },


    cancelar() {
      console.log('cancelar')
      console.log('confirmar')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Movimento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.post(`${getBaseUrl()}api/movcanc`, {
            iddata: this.idData
          }).then((res) => {

            console.log('then axios')
            console.log(res.data[0])

            if (res.data[0] === 'erro_canc_orcto') {
              this.updating = false

              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Erro ao Cancelar Movimento",
                text: res.data[1],
                showConfirmButton: false,
                timer: 4500
              })

            } else {
              this.movData.status = 'CAN'
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento cancelado com sucesso",
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })

    },


    pesqOrigem(evt) {
      console.log('pesqOrigem')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqOrigem = res.data
        });
      }
    },

    pesqDestino(evt) {
      console.log('pesqDestino')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/cidpesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqDestino = res.data
        });
      }
    },

    escolheuOrigem() {
      console.log('escolheuOrigem')
      // console.log(this.clienteData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: {coddata: this.movData.codmunenv}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.movData.codmunenv = res.data.codigo
        this.movData.municenv = res.data.descricao
        this.movData.ufenv = res.data.estado
      })
    },

    escolheuDestino() {
      console.log('escolheuDestino')
      // console.log(this.clienteData.cidade)
      api.get(`${getBaseUrl()}api/cidade`, {
        params: {coddata: this.movData.codmunfim}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.movData.codmunfim = res.data.codigo
        this.movData.municfim = res.data.descricao
        this.movData.uffim = res.data.estado
      })
    },


    escolheuEntrega() {
      console.log('escolheuEntrega')
      this.loadingCliente = true
      console.log(this.movData.entrega)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movData.entrega}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.entregaData = res.data[0]

        this.loadingCliente = false
      })
    },

    pesqEntrega(evt) {
      console.log('pesqEntrega')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqEntrega = res.data
        });
      }
    },

    pesqRecebedor(evt) {
      console.log('pesqRecebedor')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqReceb = res.data
        });
      }
    },


    escolheuRecebedor() {
      console.log('escolheuRecebedor')
      this.loadingCliente = true
      console.log(this.movData.receb)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movData.receb}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.recebedorData = res.data[0]

        this.loadingCliente = false
      })
    },


    pesqExpedidor(evt) {
      console.log('pesqExpedidor')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqExpedidor = res.data
        });
      }
    },

    escolheuExpedidor() {
      console.log('escolheuExpedidor')
      this.loadingCliente = true
      console.log(this.movData.exped)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movData.exped}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.expedidorData = res.data[0]

        this.loadingCliente = false
      })
    },

    pesqDestinatario(evt) {
      console.log('pesqDestinatario')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqDestinatario = res.data
        });
      }
    },

    escolheuDestinatario() {
      console.log('escolheuRemetente')
      this.loadingCliente = true
      console.log(this.movData.dest)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movData.dest}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.destinatarioData = res.data[0]

        this.loadingCliente = false
      })
    },

    pesqRemetente(evt) {
      console.log('pesqRemetente')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqEmit = res.data
        });
      }
    },


    escolheuRemetente() {
      console.log('escolheuRemetente')
      this.loadingCliente = true
      console.log(this.movData.remet)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movData.remet}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.emitenteData = res.data[0]

        this.loadingCliente = false
      })
    },


    carregarDados() {
      console.log('carregarDados')

      this.updating = true
      if (this.idData > 0) {
        api.get(`${getBaseUrl()}api/mov`, {
          params: {iddata: this.idData}
        }).then((res) => {
          // console.log(res.data)
          if (res.data.error) {
            console.log(res.data.error)
            this.$router.push(`/faltapermissao`);
          } else {
            console.log('then axios')
            console.log(res.data)
            this.movData = res.data[0]
            this.emitenteData = res.data[1]
            this.destinatarioData = res.data[2]
            this.empresaData = res.data[3]
            this.movItensData = res.data[4]
            this.wmsOssData = res.data[5]
            this.transpData = res.data[6]
            this.mocCtesData = res.data[8]
            this.pedTipoData = res.data[9]


            this.mediasData = res.data[10]
            this.ocorrenciasData = res.data[11]
            this.movPlpsData = res.data[12]

            this.movPlpsData.forEach((movPlp) => {
              if (movPlp.status !== '5') {
                this.exibirNovaPlp = false
              }
            })

            this.freteCotaPrinc = res.data[13]
            if (this.freteCotaPrinc) {
              this.emprSegtoData.codigo = this.freteCotaPrinc.codigo
              this.dtListPesqFreteCota = [
                {
                  'codigo': this.freteCotaPrinc.codigo,
                  'nome': this.freteCotaPrinc.nome,
                }
              ]
            }

            if (res.data[13]) {
              this.totalCorreioServ = res.data[13]
            }
            this.trackerMsgssData = res.data[14]


            console.log('this.movData.dtemissao')
            console.log(this.movData.dtemissao)

            this.movData.dtemissao = moment(this.movData.dtemissao).format('YYYY-MM-DD')

            if (this.movData.dtpreventr) {
              this.movData.dtpreventr = moment(this.movData.dtpreventr).format('YYYY-MM-DD')
            }
            if (this.movData.dtpreventrep) {
              this.movData.dtpreventrep = moment(this.movData.dtpreventrep).format('YYYY-MM-DD')
            }

            if (this.emitenteData && this.emitenteData.id) {
              this.dtListPesqEmit = [
                {
                  'codigo': this.emitenteData.codigo,
                  'nome': this.emitenteData.nome,
                }
              ]
            }

            if (this.destinatarioData && this.destinatarioData.id) {
              this.dtListPesqDestinatario = [
                {
                  'codigo': this.destinatarioData.codigo,
                  'nome': this.destinatarioData.nome,
                }
              ]
            }

            if (this.pedTipoData && this.pedTipoData.id) {
              this.dtlistPesqPedTipo = [
                {
                  'codigo': this.pedTipoData.codigo,
                  'descricao': this.pedTipoData.descricao,
                }
              ]
            }

            this.idData = this.movData.id
            this.title = `Editar Movimento (${this.movData.id}) ${this.emitenteData.nome}`


            if(this.transpData && this.transpData.servtransp){
              this.movPlpData.servico = this.transpData.servtransp
              this.pesqCorreioServico(this.movPlpData.servico)
            }

            if(this.movPlpsData.every((movPlp) => movPlp.correiosid === null)){
              this.exibirNovaPlp = true
            }

            this.updating = false

            console.log('finalizou carrega movimento')

          }
        });
      } else {

        this.title = `Criando Novo Movimento`
        this.updating = false
      }

    },

    formSubmitFinanParc() {
      console.log('formSubmitFinanParc')
      console.log(this.regSelFinParc)
      this.updating = true
      this.loadingFinanceiro = true
      this.showModalFinanParc = false

      api.post(`${getBaseUrl()}api/finanparc`, {
        finanparcData: this.regSelFinParc
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.carregarDados()
      })

    },


    baixarBoleto() {
      console.log('baixarBoleto')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Baixa de Lançamento",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {

          this.updating = true

          api.get(`${getBaseUrl()}api/fbolbaixa`, {
            params: {iddata: this.idData}
          }).then((res) => {
            console.log('then axios boleto')
            console.log(res)

            if (res.data[0]['status']['codigo'] === 400) {
              Swal.fire({
                position: "top-end",
                icon: "warning",
                title: "Erro na execução: " + res.data[0]['status']['mensagem'],
                showConfirmButton: false,
                timer: 1500
              })
            } else {

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Lançamento baixado com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })

            }

            // this.mediaBase64Data = res.data[0]
            // this.imprimirBoleto()

            this.updating = false
          })

        }

      })


    },


    prorrogarBoleto() {
      console.log('prorrogarBoleto')
      if (this.movData.vencimento === this.finanBoletoData.vencimento) {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Nova data de vencimento deve ser difierente da data anterior, favor corrigir.",
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.updating = true

        api.get(`${getBaseUrl()}api/fbolpror`, {
          params: {iddata: this.idData}
        }).then((res) => {
          console.log('then axios boleto')
          console.log(res)

          if (res.data[0]['status']['codigo'] === 400) {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: "Erro na execução: " + res.data[0]['status']['mensagem'],
              showConfirmButton: false,
              timer: 1500
            })
          } else {

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Lançamento prorrogado com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

          }

          // this.mediaBase64Data = res.data[0]
          // this.imprimirBoleto()

          this.updating = false
        })
      }
    },

    imprimirBoleto() {
      console.log('imprimirBoleto')

      const linkSource = `data:application/pdf;base64,${this.mediaBase64Data.base64}`;
      const downloadLink = document.createElement("a");
      const fileName = `boleto_lancto_${this.idData}.pdf`;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },


    novoBoleto(finanParc) {
      console.log('novoBoleto')
      console.log(finanParc)
      this.updating = true

      if (finanParc.nossonum) {
        this.consultarBoleto(finanParc.id)
      } else {
        api.get(`${getBaseUrl()}api/fbolincl`, {
          params: {iddata: finanParc.id}
        }).then((res) => {
          console.log('then axios boleto')
          console.log(res)

          this.mediaBase64Data = res.data[0]
          this.imprimirBoleto()

          this.updating = false
        })

      }


    },

    consultarBoleto(idparcela) {
      console.log('consultarBoleto')
      this.updating = true
      api.get(`${getBaseUrl()}api/fbolcons`, {
        params: {iddata: idparcela}
      }).then((res) => {

        console.log('then axios consboleto')
        console.log(res)

        this.mediaBase64Data = res.data[0]
        this.imprimirBoleto()

        this.updating = false

        // console.log('then axios boleto')
        // console.log(res)
        // this.updating = false
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Consulta realizada com sucesso!",
        //   text: "Status atual do boleto: " + res.data[0]['resultado']['situacaoBoleto'],
        //   showConfirmButton: false,
        //   timer: 3500
        // })
      })

    },

    segundaViaBoleto() {
      console.log('segundaViaBoleto')
      this.updating = true
      api.get(`${getBaseUrl()}api/fbolsvia`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios boleto')
        console.log(res)

        const pdfBoleto = res.data[0].resultado.pdfBoleto

        const linkSource = `data:application/pdf;base64,${pdfBoleto}`;
        const downloadLink = document.createElement("a");
        const fileName = `boleto_lancto_${this.idData}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click()

        this.updating = false

      })

    },


    nomeStatus(strEntr) {
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Em Aberto'
          break
        case 'P':
          result = 'Quitado Parcial'
          break
        case 'Q':
          result = 'Quitado'
          break
        case 'X':
          result = 'Cancelado'
          break
        case 'PR':
          result = 'Em Produção'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    nomeStatusOcor(strEntr) {
      let result = strEntr
      switch (strEntr) {
        case 'PD':
          result = 'Pendente'
          break
        case 'EN':
          result = 'Enviado'
          break
      }
      return result
    },

    tipoEnvioOcor(strEntr) {
      let result = strEntr
      switch (strEntr) {
        case 'ENI':
          result = 'Enviar Imediatamente'
          break
        case 'ENL':
          result = 'Enviar até limite'
          break
      }
      return result
    },


    nomeStatusParc(strEntr) {
      let result = 'Não Definido'
      switch (strEntr) {
        case 'AB':
          result = 'Em Aberto'
          break
        case 'QP':
          result = 'Quitado Parcial'
          break
        case 'QT':
          result = 'Quitado'
          break
        case 'CX':
          result = 'Cancelado'
          break
        case 'EL':
          result = 'Elaboração'
          break
        default:
          result = 'Não Definido'
          break
      }
      return result
    },

    pesqCliente(evt) {
      console.log('pesqCliente')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqCli = res.data
        });
      }
    },

    pesqFinConta(evt) {
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/fcontapesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFinConta = res.data
        });
      }
    },

    escolheuCli() {
      console.log('escolheuCli')
      this.loadingCliente = true
      console.log(this.movData.pessoa)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movData.pessoa}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.clienteData = res.data[0]

        this.loadingCliente = false
      })
    },


    salvar() {

      if (this.movData.status !== 'EL') {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status em Elaboração não pode ser manipulado, favor confirmar movimento relacionado antes.",
          showConfirmButton: false,
          timer: 3000
        })
      } else {
        this.submitted = true
        this.submitMov = true
        this.v$.$touch()

        console.log('salvarMov')
        if (this.movData.remet && this.movData.numero !== '' && this.movData.valor > 0) {
          console.log('salvarMov_00')
          this.updating = true

          this.errosValid = []
          api.post(`${getBaseUrl()}api/mov`, {
            movData: this.movData
          }).then((res) => {
            console.log('then axios')
            console.log(res)

            if (this.idData === 0) {
              console.log('redirecionar')
              this.$router.replace({path: `/mov/editar/${res.data[0].id}`})
              this.idData = res.data[0].id

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento confirmado com sucesso",
                showConfirmButton: false,
                timer: 1500
              })

              this.carregarDados()

              //  this.movData = res.data[0]
              //  this.updating = false

            } else {

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Movimento confirmado com sucesso",
                showConfirmButton: false,
                timer: 1500
              })


              this.carregarDados()
            }

          }).catch((err) => {
            console.log('erro axios')
            // console.log(err)
            // console.log(err.response)
            // console.log(err.response.data.errors)
            let erros = err.response.data.errors
            console.log(erros)
            console.log(typeof erros)
            let listaErros = []
            Object.keys(erros).forEach(key => {
              console.log(key, erros[key]);
              listaErros.push({
                'titulo': key,
                'mensagem': erros[key]
              })
            });
            this.errosValid = listaErros
            this.updating = false

          })
        } else {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor selecionar o fornecedor, emissão, número e valor antes de salvar",
            showConfirmButton: false,
            timer: 1500
          })
        }
      }
    },

    formatDecimal(value) {
      // return parseFloat(value).toFixed(2)
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value).toFixed(2)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4})
      }
      return "0,00"
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  mounted() {
    console.log('mounted_movimento_editar_0')

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    // console.log('this.userLogged')
    // console.log(this.userLogged)

    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra) {
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    this.carregarDados()


  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movData.status"/>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">


              <b-button variant="outline-primary" class="mx-2" @click="salvar"
                        v-if="movData.status === 'EL' && empresaData.regtrib !== '99'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>


              <b-button variant="outline-info" class="mx-2" v-if="idData > 0 && movData.status === 'EL' "
                        @click="confirmar">
                <i class="bx bx-check-circle font-size-16 align-middle me-2"></i>
                Confirmar
              </b-button>


              <b-button variant="outline-success" class="mx-2" v-if="idData > 0 && movData.status === 'PR' "
                        @click="abrirOSSep">
                <i class="bx bx-check-circle font-size-16 align-middle me-2"></i>
                Abrir OS Separação
              </b-button>


              <b-button variant="outline-dark" class="mx-2" @click="rastreamento">
                <i class="bx bx-map-pin font-size-16 align-middle me-2"></i>
                Rastreamento
              </b-button>


              <b-button v-if="!bloqExibEconofrete" variant="outline-info" class="mx-2" @click="showModalPesoManual = true"
                        :disabled="movData.id === 0">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotar EconoFrete
              </b-button>


              <b-button variant="outline-warning" class="mx-2"
                        v-if="userLogged.tipo === 'admin'"
                        @click="cotarFreteInterno"
                        :disabled="movData.id === 0">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Cotar EconoPro
              </b-button>




              <b-button variant="outline-warning" class="mx-2"
                        v-if="movData.tipo && idData > 0 && movData.status !== 'TRA' && movData.status !== 'CAN'"
                        @click="efetivarOperacao">
                <i class="bx bx-file-blank font-size-16 align-middle me-2"></i>
                Efetivar Operação
              </b-button>


              <b-button variant="outline-success" class="mx-2" v-if="idData > 0" @click="novoAnexo">
                <i class="bx bx-upload font-size-16 align-middle me-2"></i>
                Anexar Comprovante
              </b-button>


              <b-button variant="outline-warning" class="mx-2" v-if="idData > 0" @click="plpCorreios">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                PLP Correios
              </b-button>

              <b-button variant="outline-success" class="mx-2" v-if="idData > 0" @click="abrirLogReversa">
                <i class="bx bxs-truck font-size-16 align-middle me-2"></i>
                Logística Reversa (Correios)
              </b-button>


              <b-button variant="outline-danger" class="mx-2" @click="cancelar" v-if="movData.status !== 'CAN'">
                <i class="bx bx-block font-size-16 align-middle me-2"></i>
                Cancelar Movimento
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="novaPrevEntr">
                <i class="bx bx-calendar font-size-16 align-middle me-2"></i>
                Nova Previsão
              </b-button>

              <!-- Botão adicionado: envia um array com o id da mov para a API -->
              <b-button variant="outline-primary" class="mx-2" @click="imprimirDanfe"
                        :disabled="idData === 0 || movData.id === 0">
                <i class="bx bx-send font-size-16 align-middle me-2"></i>
                Imprimir DANFE
              </b-button>



              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <!--              <button class="btn btn-success"-->
              <!--                      @click="confirmarOrcamento"-->
              <!--                      :disabled="movData.status !== 'EL'"-->
              <!--                      v-if="movData.status === 'EL' && orctoItensData && orctoItensData.length > 0">-->
              <!--                <i class="mdi mdi-rocket-launch me-1 text-end"></i> SUCESSO!-->
              <!--              </button>-->


            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="checkout-tabs" v-if="!updating">


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-1
                      class="text-dark"
                      href="javascript: void(0);"
                  >Dados Principais</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                <b-card-body>

                  <div class="row mb-2">


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="codigo">Código</label>
                        <input
                            id="codigo"
                            v-model="movData.codigo"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Código"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="mb-3">
                        <label for="codhub">Código Hub</label>
                        <input
                            id="codhub"
                            v-model="movData.codhub"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Código Hub"/>
                      </div>
                    </div>

                    <!--                      <div class="col-md-3">-->
                    <!--                        <div class="mb-3">-->
                    <!--                          <label for="tipo" >Tipo de Operação</label>-->
                    <!--                          <input-->
                    <!--                              id="tipo"-->
                    <!--                              v-model="movData.tipo"-->
                    <!--                              type="text"-->
                    <!--                              :disabled="true"-->
                    <!--                              class="form-control"-->
                    <!--                              placeholder="Tipo de Operação"/>-->
                    <!--                        </div>-->
                    <!--                      </div>-->


                    <div class="col-md-3">
                      <div class="mb-3">
                        <span>Tipo de Operação</span>

                        <multiselect id="tipooperacao"
                                     @search-change="pesqPedTipo"
                                     @select="escolheuPedTipo"
                                     v-model="movData.tipo"
                                     placeholder="Pesquisar tipo de operação"
                                     :options="dtlistPesqPedTipo"
                                     :searchable="true"
                                     label="descricao"
                                     track-by="descricao"
                                     value-prop="codigo">
                          <template #option="slotProps">
                            <div class="row">
                              <div>
                                <span class="text-info">
                                  {{ slotProps.option.codigo }}
                                </span>
                                <span class="mx-4">

                                </span>
                              </div>
                              <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                              <span class="mx-4"></span>
                              <div class="align-items-end text-end align-content-end">
                                {{ formatDateTime(slotProps.option.created_at) }}
                              </div>
                            </div>
                          </template>
                        </multiselect>

                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="numnf">Número NF</label>
                        <input
                            id="numnf"
                            v-model="movData.codigo"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Número NF"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="emissao">Emissão NF</label>
                        <input
                            id="emissao"
                            v-model="movData.dtemissao"
                            type="date"
                            class="form-control"
                            placeholder="Data de emissão NF"
                            :disabled="true"
                            :class="{'is-invalid': submitted && v$.movData.dtemissao.$error,}"/>
                        <div v-if="submitted && v$.movData.dtemissao.$error"
                             class="invalid-feedback">
                          <span v-if="v$.movData.dtemissao.required.$message">{{
                              v$.movData.dtemissao.required.$message
                            }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="chave">Chave</label>
                        <input
                            id="numnf"
                            v-model="movData.chave"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder=">Chave"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="dtpedido">Data Pedido</label>
                        <input
                            id="dtpedido"
                            v-model="movData.dtpedido"
                            type="date"
                            :disabled="true"
                            class="form-control"
                            placeholder="Data do Pedido"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="dtentrega">Data Entrega</label>
                        <input
                            id="dtentrega"
                            v-model="movData.dtentrega"
                            type="date"
                            :disabled="true"
                            class="form-control"
                            placeholder="Data de Entrega"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="dtconfer">Data Conferência</label>
                        <input
                            id="dtconfer"
                            v-model="movData.dtconfer"
                            type="date"
                            :disabled="true"
                            class="form-control"
                            placeholder="Data de Conferência"/>
                      </div>
                    </div>


                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="conferente">Conferente</label>
                        <input
                            id="conferente"
                            v-model="movData.conferente"
                            type="text"
                            :disabled="true"
                            class="form-control"
                            placeholder="Conferente"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="dtconfer">Data Previsão Entrega</label>
                        <input
                            id="dtpreventr"
                            v-model="movData.dtpreventr"
                            type="date"
                            :disabled="true"
                            class="form-control"
                            placeholder="Data  Previsão Entrega"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="dtpreventrep">Data Previsão Reprogramada</label>
                        <input
                            id="dtpreventr"
                            v-model="movData.dtpreventrep"
                            type="date"
                            :disabled="true"
                            class="form-control"
                            placeholder="Data Previsão Reprogramada"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="mb-3">

                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="qtditens">Qtd. Itens</label>
                        <input
                            id="qtditens"
                            v-model="movData.qtditens"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Qtd. Itens"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="qtditenspend">Itens Pendentes</label>
                        <input
                            id="qtditenspend"
                            v-model="movData.qtditenspend"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Itens Pendentes"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="qtditensconf">Itens Conferidos</label>
                        <input
                            id="qtditensconf"
                            v-model="movData.qtditensconf"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Itens Conferidos"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="qtdetiqs">Etiquetas</label>
                        <input
                            id="qtdetiqs"
                            v-model="movData.qtdetiqs"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Etiquetas"/>
                      </div>
                    </div>


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="valorliq">Valor</label>
                        <input
                            id="valorliq"
                            v-model="movData.valorliq"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Valor Líquido"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="valordesc">Valor Desconto</label>
                        <input
                            id="valordesc"
                            v-model="movData.valordesc"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Valor Desconto"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="valorfrtloj">Valor Frete Loja</label>
                        <input
                            id="valorfrtloj"
                            v-model="movData.valorfrtloj"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Valor Frete Loja"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="valorfrete">Frete Loja</label>
                        <input
                            id="valorfrete"
                            v-model="movData.valorfrete"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Frete Loja"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="taxagat">Taxa Gateway</label>
                        <input
                            id="taxagat"
                            v-model="movData.taxagat"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Taxa Gateway"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="taxaloj">Taxa Loja</label>
                        <input
                            id="taxaloj"
                            v-model="movData.taxaloj"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Taxa Loja"/>
                      </div>
                    </div>

                    <!--                    <div class="col-md-2">-->
                    <!--                      <div class="mb-3">-->
                    <!--                        <label for="peso">Peso</label>-->
                    <!--                        <input-->
                    <!--                            id="peso"-->
                    <!--                            v-model="movData.peso"-->
                    <!--                            type="number"-->
                    <!--                            :disabled="true"-->
                    <!--                            class="form-control"-->
                    <!--                            placeholder="Peso" />-->
                    <!--                      </div>-->
                    <!--                    </div>-->


                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="pesoliq">Peso Líquido</label>
                        <input
                            id="pesoliq"
                            v-model="movData.pesoliq"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Peso Líquido"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="pesobrt">Peso Bruto</label>
                        <input
                            id="pesobrt"
                            v-model="movData.pesobrt"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Peso Bruto"/>
                      </div>
                    </div>

                    <div class="col-md-2" @click="showModalPesoManual = true">
                      <div class="mb-3">
                        <label for="pesomanual">Peso Cotação</label>
                        <input
                            id="pesomanual"
                            v-model="movData.pesomanual"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Peso Cotação"/>
                      </div>
                    </div>

                    <div class="col-md-2" @click="showModalPesoManual = true">
                      <div class="mb-3">
                        <label for="dimemanual">Dimensões Cotação</label>
                        <input
                            id="dimemanual"
                            v-model="movData.dimemanual"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Dimensões Cotação"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <div class="mb-3">
                        <label for="qtdvol">Qtd.Volumes</label>
                        <input
                            id="qtdvol"
                            v-model="movData.qtdvol"
                            type="number"
                            :disabled="true"
                            class="form-control"
                            placeholder="Qtd.Volumes"/>
                      </div>
                    </div>


                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-2
                      class="text-dark"
                      href="javascript: void(0);"
                  >Emitente</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-2" visible accordion="my-accordion-2" role="tabpanel">
                <b-card-body>

                  <div class="row mb-2">
                    <div class="col-md-4">
                      <label for="emitnome">Nome / Razão Social</label>

                      <div class="position-relative">
                        <input
                            id="emitnome"
                            type="text"
                            v-model="emitenteData.nome"
                            class="form-control"
                            :disabled="true"
                            placeholder="Nome / Razão Social"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="emitcnpj">CNPJ</label>
                      <div class="position-relative">
                        <input
                            id="emitcnpj"
                            type="text"
                            v-model="emitenteData.cnpj"
                            class="form-control"
                            :disabled="true"
                            placeholder="CNPJ"/>
                      </div>


                    </div>

                    <div class="col-md-3">
                      <label for="emitinsc">Inscrição Estadual</label>
                      <div class="position-relative">
                        <input
                            id="emitinsc"
                            type="text"
                            v-model="emitenteData.inscricao"
                            class="form-control"
                            :disabled="true"
                            placeholder="Inscrição Estadual"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="emittel1">Telefone</label>
                      <div class="position-relative">
                        <input
                            id="emittel1"
                            type="text"
                            v-model="emitenteData.tel1"
                            class="form-control"
                            :disabled="true"
                            placeholder="Telefone"/>
                      </div>
                    </div>

                  </div>


                  <div class="row mb-2">

                    <div class="col-md-4">
                      <label for="emitender">Endereço</label>
                      <div class="position-relative">
                        <input
                            id="emitender"
                            type="text"
                            v-model="emitenteData.rua"
                            class="form-control"
                            :disabled="true"
                            placeholder="Endereço"/>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <label for="emitnumero">Número</label>
                      <div class="position-relative">
                        <input
                            id="emitnumero"
                            type="text"
                            v-model="emitenteData.numero"
                            class="form-control"
                            :disabled="true"
                            placeholder="Número"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="emitbairro">Bairro</label>
                      <div class="position-relative">
                        <input
                            id="emitbairro"
                            type="text"
                            v-model="emitenteData.bairro"
                            class="form-control"
                            :disabled="true"
                            placeholder="Bairro"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="emitcep">CEP</label>
                      <div class="position-relative">
                        <input
                            id="emitcep"
                            type="text"
                            v-model="emitenteData.cep"
                            class="form-control"
                            :disabled="true"
                            placeholder="CEP"/>
                      </div>
                    </div>
                  </div>


                  <div class="row mb-2">


                    <div class="col-md-4">
                      <label for="emitmunicipio">Município</label>
                      <div class="position-relative">
                        <input
                            id="emitmunicipio"
                            type="text"
                            v-model="emitenteData.cidade"
                            class="form-control"
                            :disabled="true"
                            placeholder="Município"/>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <label for="emitestado">UF</label>
                      <div class="position-relative">
                        <input
                            id="emitestado"
                            type="text"
                            v-model="emitenteData.estado"
                            class="form-control"
                            :disabled="true"
                            placeholder="UF"/>
                      </div>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-3
                      class="text-dark"
                      href="javascript: void(0);"
                  >Destinatário</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-3" visible accordion="my-accordion-3" role="tabpanel">
                <b-card-body>


                  <div class="row mb-2">
                    <div class="col-md-4">
                      <label for="destnome">Nome / Razão Social</label>

                      <div class="position-relative">
                        <input
                            id="destnome"
                            type="text"
                            v-model="destinatarioData.nome"
                            class="form-control"
                            :disabled="true"
                            placeholder="Nome / Razão Social"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="destcnpj">CNPJ</label>
                      <div class="position-relative">
                        <input
                            id="destcnpj"
                            type="text"
                            v-model="destinatarioData.cnpj"
                            class="form-control"
                            :disabled="true"
                            placeholder="CNPJ"/>
                      </div>


                    </div>

                    <div class="col-md-3">
                      <label for="destinsc">Inscrição Estadual</label>
                      <div class="position-relative">
                        <input
                            id="destinsc"
                            type="text"
                            v-model="destinatarioData.inscricao"
                            class="form-control"
                            :disabled="true"
                            placeholder="Inscrição Estadual"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="desttel1">Telefone</label>
                      <div class="position-relative">
                        <input
                            id="desttel1"
                            type="text"
                            v-model="destinatarioData.tel1"
                            class="form-control"
                            :disabled="true"
                            placeholder="Telefone"/>
                      </div>
                    </div>

                  </div>

                  <div class="row mb-2">


                    <div class="col-md-4">
                      <label for="destender">Endereço</label>
                      <div class="position-relative">
                        <input
                            id="destender"
                            type="text"
                            v-model="destinatarioData.rua"
                            class="form-control"
                            :disabled="true"
                            placeholder="Endereço"/>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <label for="destnumero">Número</label>
                      <div class="position-relative">
                        <input
                            id="destnumero"
                            type="text"
                            v-model="destinatarioData.numero"
                            class="form-control"
                            :disabled="true"
                            placeholder="Número"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="destbairro">Bairro</label>
                      <div class="position-relative">
                        <input
                            id="destbairro"
                            type="text"
                            v-model="destinatarioData.bairro"
                            class="form-control"
                            :disabled="true"
                            placeholder="Bairro"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="destcep">CEP</label>
                      <div class="position-relative">
                        <input
                            id="destcep"
                            type="text"
                            v-model="destinatarioData.cep"
                            class="form-control"
                            :disabled="true"
                            placeholder="CEP"/>
                      </div>
                    </div>

                  </div>

                  <div class="row mb-2">

                    <div class="col-md-4">
                      <label for="destmunicipio">Município</label>
                      <div class="position-relative">
                        <input
                            id="destmunicipio"
                            type="text"
                            v-model="destinatarioData.cidade"
                            class="form-control"
                            :disabled="true"
                            placeholder="Município"/>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <label for="destestado">UF</label>
                      <div class="position-relative">
                        <input
                            id="destestado"
                            type="text"
                            v-model="destinatarioData.estado"
                            class="form-control"
                            :disabled="true"
                            placeholder="UF"/>
                      </div>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-6
                      class="text-dark"
                      href="javascript: void(0);"
                  >Transportador</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-6" visible accordion="my-accordion-6" role="tabpanel">
                <b-card-body v-if="transpData">


                  <div class="row mb-2">
                    <div class="col-md-4">
                      <label for="destnome">Nome / Razão Social</label>

                      <div class="position-relative">
                        <input
                            id="destnome"
                            type="text"
                            v-model="transpData.nome"
                            class="form-control"
                            :disabled="true"
                            placeholder="Nome / Razão Social"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="destcnpj">CNPJ</label>
                      <div class="position-relative">
                        <input
                            id="destcnpj"
                            type="text"
                            v-model="transpData.cnpj"
                            class="form-control"
                            :disabled="true"
                            placeholder="CNPJ"/>
                      </div>


                    </div>

                    <div class="col-md-3">
                      <label for="destinsc">Inscrição Estadual</label>
                      <div class="position-relative">
                        <input
                            id="destinsc"
                            type="text"
                            v-model="transpData.inscricao"
                            class="form-control"
                            :disabled="true"
                            placeholder="Inscrição Estadual"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="desttel1">Telefone</label>
                      <div class="position-relative">
                        <input
                            id="desttel1"
                            type="text"
                            v-model="transpData.tel1"
                            class="form-control"
                            :disabled="true"
                            placeholder="Telefone"/>
                      </div>
                    </div>

                  </div>

                  <div class="row mb-2">


                    <div class="col-md-4">
                      <label for="destender">Endereço</label>
                      <div class="position-relative">
                        <input
                            id="destender"
                            type="text"
                            v-model="transpData.rua"
                            class="form-control"
                            :disabled="true"
                            placeholder="Endereço"/>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <label for="destnumero">Número</label>
                      <div class="position-relative">
                        <input
                            id="destnumero"
                            type="text"
                            v-model="transpData.numero"
                            class="form-control"
                            :disabled="true"
                            placeholder="Número"/>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <label for="destbairro">Bairro</label>
                      <div class="position-relative">
                        <input
                            id="destbairro"
                            type="text"
                            v-model="transpData.bairro"
                            class="form-control"
                            :disabled="true"
                            placeholder="Bairro"/>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="destcep">CEP</label>
                      <div class="position-relative">
                        <input
                            id="destcep"
                            type="text"
                            v-model="transpData.cep"
                            class="form-control"
                            :disabled="true"
                            placeholder="CEP"/>
                      </div>
                    </div>

                  </div>

                  <div class="row mb-2">

                    <div class="col-md-4">
                      <label for="destmunicipio">Município</label>
                      <div class="position-relative">
                        <input
                            id="destmunicipio"
                            type="text"
                            v-model="transpData.cidade"
                            class="form-control"
                            :disabled="true"
                            placeholder="Município"/>
                      </div>
                    </div>


                    <div class="col-md-3">
                      <label for="destestado">UF</label>
                      <div class="position-relative">
                        <input
                            id="destestado"
                            type="text"
                            v-model="transpData.estado"
                            class="form-control"
                            :disabled="true"
                            placeholder="UF"/>
                      </div>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-4
                      class="text-dark"
                      href="javascript: void(0);"
                  >Informações Adicionais</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-4" visible accordion="my-accordion-4" role="tabpanel">
                <b-card-body>


                  <div class="row">

                    <div class="col-md-12">
                      <div class="mb-3">
                        <label for="rasturl">URL Rastreio</label>
                        <textarea
                            id="rasturl"
                            v-model="movData.rasturl"
                            type="text"
                            rows="1"
                            :disabled="true"
                            class="form-control"
                            placeholder="URL Rastreio"/>
                      </div>
                    </div>

                  </div>


                  <div class="row">
                    <div class="col-md-12">
                      <div class="mb-3">
                        <label for="obsc">Observações</label>
                        <textarea
                            id="obsc"
                            v-model="movData.obs"
                            type="text"
                            rows="3"
                            class="form-control"
                            :disabled="empresaData.regtrib === '99'"
                            placeholder="Observações"/>
                      </div>
                    </div>
                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-5
                      class="text-dark"
                      href="javascript: void(0);"
                  >Itens Nota Fiscal</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-5" visible accordion="my-accordion-5" role="tabpanel">
                <b-card-body>

                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">Código</th>
                        <th scope="col">Descrição</th>

                        <th scope="col">UN</th>
                        <th scope="col">Lote</th>
                        <th scope="col" class="text-end">Qtde</th>
                        <th scope="col" class="text-end">Peso</th>
                        <th scope="col" class="text-end">Valor unit.</th>
                        <th scope="col" class="text-end">Valor total</th>
                        <th scope="col" class="text-end">Ações</th>

                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="item in movItensData" :key="item.id">
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <a class="text-dark"
                               href="javascript: void(0);">
                              {{ item.produto }}
                            </a>
                          </h5>
                          <p v-if="item.idprod > 0"
                             class="text-muted mb-0">
                          </p>

                        </td>
                        <td>
                          <a class="text-dark"
                             @click="abrirModalItem(item)"
                             href="javascript: void(0);">
                            {{ item.descprod }}
                          </a>
                          <p><span class="text-black-50"> {{ item.lote }} </span></p>
                        </td>

                        <td class="text-muted mb-0">{{ item.und }}</td>
                        <td class="text-muted mb-0">{{ item.lote }}</td>
                        <td class="text-muted mb-0 text-end">{{ formatDecimal(item.qtd) }}</td>
                        <td class="text-muted mb-0 text-end">{{ formatDecimal(item.peso) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrunitliq) }}</td>
                        <td class="text-end">{{ formatDecimal(item.vlrtotalliq) }}</td>
                        <td>
                          <div class="button-items text-end" title="Desconsiderar fluxo saldo do item">

                            <b-button :variant="item.desconsidsaldo ? 'outline-info' : 'outline-danger'" @click="desconsiderarFluxoSaldoItem(item)">
                              <i 
                                class="d-block font-size-16"
                                :class="item.desconsidsaldo ? 'bx bx-transfer' : 'bx bx-block'"    
                              ></i>
                            </b-button>

                          </div>
                        </td>
                      </tr>

                      </tbody>
                    </table>
                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-10
                      class="text-dark"
                      href="javascript: void(0);"
                  >CT-e(s) Nota Fiscal</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-10" visible accordion="my-accordion-10" role="tabpanel">
                <b-card-body>

                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-nowrap">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Chave</th>
                        <th scope="col">Número</th>
                        <th scope="col">Emissão</th>
                        <th scope="col" class="text-end">Valor</th>

                      </tr>
                      </thead>
                      <tbody>

                      <tr v-for="item in mocCtesData" :key="item.id">
                        <td>
                          <h5 class="font-size-14 text-truncate">
                            <a class="text-dark"
                               @click="abrirCte(item.id)"
                               href="javascript: void(0);">
                              {{ item.id }}
                            </a>
                          </h5>
                          <p v-if="item.id > 0"
                             class="text-muted mb-0">
                          </p>

                        </td>
                        <td>
                          <a class="text-dark"
                             @click="abrirCte(item.id)"
                             href="javascript: void(0);">
                            {{ item.chave }}
                          </a>
                          <!--                          <p><span class="text-black-50"> {{ item.lote }} </span></p>-->
                        </td>

                        <td class="text-muted mb-0">{{ item.numero }}</td>
                        <td class="text-muted mb-0">{{ formatDate(item.dtemissao) }}</td>
                        <td class="text-end">{{ formatDecimal(item.valor) }}</td>


                      </tr>

                      </tbody>
                    </table>
                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-12
                      class="text-dark"
                      href="javascript: void(0);"
                  >Anexos do Movimento</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-12" visible accordion="my-accordion-12" role="tabpanel">
                <b-card-body>

                  <div class="card-body">
                    <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                    <!--                    <p class="card-title-desc">-->
                    <!--                      Pasta de Anexos do Cliente</p>-->

                    <div class="row" v-if="loadingFiles">
                      <div class="col-12 text-center">
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                      </div>
                    </div>


                    <div class="table-responsive" v-if="!loadingFiles">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Arquivo</th>
                          <th scope="col">Data</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in mediasData" :key="data.id">

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            {{ data.descricao }}
                          </td>

                          <td>
                        <span class="text-dark">
                          {{ data.nome }}
                        </span>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                          <span class="text-dark">
                            {{ formatDateTime(data.created_at) }}
                          </span>
                            </h5>
                          </td>


                          <td>
                            <div class="button-items">

                              <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                                <i class="mdi mdi-download d-block font-size-16"></i>
                              </b-button>

                              <b-button variant="outline-danger" @click="delFile(data.id)"
                                        :disabled="data.email === 'admin@admin.com.br'">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>

                            </div>
                          </td>


                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-11
                      class="text-dark"
                      href="javascript: void(0);"
                  >Ocorrências Movimento</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-11" visible accordion="my-accordion-11" role="tabpanel">
                <b-card-body>

                  <div class="card-body">
                    <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                    <!--                    <p class="card-title-desc">-->
                    <!--                      Pasta de Anexos do Cliente</p>-->

                    <div class="row" v-if="loadingFiles">
                      <div class="col-12 text-center">
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                      </div>
                    </div>


                    <div class="table-responsive" v-if="!loadingFiles">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Status</th>
                          <th scope="col">Tipo Envio</th>
                          <th scope="col">Usuário</th>
                          <th scope="col">Criado</th>
                          <th scope="col">Enviado</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in ocorrenciasData" :key="data.id">

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            {{ nomeStatusOcor(data.status) }}
                          </td>

                          <td>
                            <span class="text-dark">
                              {{ tipoEnvioOcor(data.tpenvio) }}
                            </span>
                          </td>

                          <td>
                            <span class="text-dark">
                              {{ data.created_by }}
                            </span>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.created_at) }}
                              </span>
                            </h5>
                          </td>

                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.envio) }}
                              </span>
                            </h5>
                          </td>


                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>


      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-14
                      class="text-dark"
                      href="javascript: void(0);"
                  >Ordens de Serviço</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-14" visible accordion="my-accordion-14" role="tabpanel">
                <b-card-body>

                  <div class="card-body">
                    <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                    <!--                    <p class="card-title-desc">-->
                    <!--                      Pasta de Anexos do Cliente</p>-->

                    <div class="row" v-if="loadingFiles">
                      <div class="col-12 text-center">
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                      </div>
                    </div>


                    <div class="table-responsive" v-if="!loadingFiles">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Status</th>
                          <th scope="col" class="text-end">Separação</th>
                          <th scope="col" class="text-end">Separado(%)</th>
                          <th scope="col" class="text-end">Disponível</th>
                          <th scope="col" class="text-end">Lida</th>
                          <th scope="col" class="text-end">Total</th>
                          <th scope="col">Transp.</th>
                          <th scope="col" class="text-end">Criado</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in wmsOssData" :key="data.id">

                          <td>

                            <!--                            <a href="javascript: void(0);" class="btn btn-primary mt-3 disabled">-->
                            <!--&lt;!&ndash;                              <i class="mdi mdi-plus me-1"></i> Adicionar Novo&ndash;&gt;-->


                            <!--                              <h5 class="font-size-14 text-truncate">-->
                            <!--                              <span class="text-dark">-->
                            <!--                                {{ data.id }}-->
                            <!--                              </span>-->
                            <!--                              </h5>-->

                            <!--                            </a>-->


                            <a href="javascript: void(0);" class="text-body fw-bold" @click="abrirOSSep(data.id)">
                              {{ data.id }}
                            </a>


                          </td>

                          <td>
                            {{ nomeStatusOcor(data.status) }}
                          </td>

                          <td class="text-end">
                            {{ nomeStatusOcor(data.stsep) }}
                          </td>

                          <td class="text-end">
                            <span class="text-dark">
                              {{ formatDecimal(data.percsep) }}
                            </span>
                          </td>

                          <td class="text-end">
                            <span class="text-dark">
                              {{ data.qtdlida }}
                            </span>
                          </td>

                          <td class="text-end">
                            <span class="text-dark">
                              {{ data.qtddisp }}
                            </span>
                          </td>

                          <td class="text-end">
                            <span class="text-dark">
                              {{ data.total }}
                            </span>
                          </td>

                          <td>
                            <span class="text-dark">
                              {{ data.created_by }}
                            </span>
                          </td>

                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.created_at) }}
                              </span>
                            </h5>
                          </td>


                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>



      <b-card-text>
        <div class="card">
          <div class="card-body">

            <b-card no-body class="mb-1 shadow-none">
              <b-card-header header-tag="header" role="tab">
                <h6 class="m-0">
                  <a
                      v-b-toggle.accordion-15
                      class="text-dark"
                      href="javascript: void(0);"
                  >Mensagens de Rastreamento</a>
                </h6>
              </b-card-header>
              <b-collapse id="accordion-15" visible accordion="my-accordion-15" role="tabpanel">
                <b-card-body>

                  <div class="card-body">
                    <!--                    <h4 class="card-title">Pasta de Anexos</h4>-->
                    <!--                    <p class="card-title-desc">-->
                    <!--                      Pasta de Anexos do Cliente</p>-->

                    <div class="row" v-if="loadingFiles">
                      <div class="col-12 text-center">
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                        <b-spinner type="grow"
                                   class="m-6 mx-2"
                                   variant="secondary"
                                   role="status">
                        </b-spinner>
                      </div>
                    </div>


                    <div class="table-responsive" v-if="!loadingFiles">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">ID Evento</th>
                          <th scope="col">Status</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Destinatário</th>
                          <th scope="col">CNPJ Destinatário</th>
                          <th scope="col">E-mail</th>
                          <th scope="col">Telefone</th>
                          <th scope="col">Mensagem</th>
                          <th scope="col">Data Status</th>
                          <th scope="col" class="text-end">Criado</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in trackerMsgssData" :key="data.id">
                          <td>
                            <a href="javascript: void(0);" class="text-body fw-bold" >
                              {{ data.id }}
                            </a>
                          </td>
                          <td>
                            {{ data.tracckerevent_id }}
                          </td>
                          <td>
                            {{ data.status }}
                          </td>
                          <td>
                            {{ data.tipo }}
                          </td>
                          <td>
                            {{ data.destnome }}
                          </td>
                          <td>
                            {{ data.destcnpj }}
                          </td>
                          <td>
                            {{ data.destmail }}
                          </td>
                          <td>
                            {{ data.desttel }}
                          </td>
                          <td>
                            {{ data.mensagem }}
                          </td>
                          <td>
                            {{ data.datastatus }}
                          </td>
                          <td class="text-end">
                            <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ formatDateTime(data.created_at) }}
                              </span>
                            </h5>
                          </td>


                        </tr>

                        </tbody>
                      </table>
                    </div>

                  </div>


                </b-card-body>
              </b-collapse>
            </b-card>

          </div>
        </div>
      </b-card-text>



    </div>


    <b-modal size="xl"
             :title="'Cotação de Frete | Peso: ' + formatDecimal(pesoAcotar) + ' | Dimensões: ' + formatDecimal(movData.dimemanual)"
             v-model="showModalCotarFrete"
             centered hide-footer>
      <div class="col-md-12">

        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteListData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col">TranspNome</th>
              <th scope="col" class="">Frete R$</th>
              <th scope="col" class="">Frete %</th>
              <th scope="col" class="">Frete KG</th>


              <th scope="col" class="text-end">PrazoDias</th>

              <th scope="col">TranspCNPJ</th>
              <th scope="col">TranspEmail</th>
              <th scope="col" class="text-end">Mov.Cot.ID</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotaFreteListData" :key="data.id">
              <td>

                <a href="javascript:void(0);"
                   v-b-tooltip.hover
                   class="action-icon text-info mx-2"
                   title="Escolher Transportadora"
                   @click="escolherFrete(data.WSOut_Frete_Val)">
                  <i class="mdi mdi-check-outline font-size-18"></i>
                </a>


              </td>

              <td>
                {{ data.WSOut_Transp_Nome }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.WSOut_Frete_Val) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / movData.valorliq) * 100) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / pesoAcotar) * 100) }}
              </td>

              <!--              <td>-->
              <!--                <div>-->
              <!--                  <h5 class="text-truncate font-size-14">-->
              <!--                    {{ formatDateTime(data.WSOut_DataH) }}-->
              <!--                  </h5>-->
              <!--                </div>-->
              <!--              </td>-->

              <td class="text-end">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.WSOut_Prazo_Dias }}
              </td>

              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_Indic }}-->
              <!--              </td>-->
              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_MovCot_ID }}-->
              <!--              </td>-->
              <!--              <td class="text-end">-->
              <!--                {{ data.WSOut_MovSim_ID }}-->
              <!--              </td>-->
              <!--              <td>-->
              <!--                {{ data.WSOut_NotaS }}-->
              <!--              </td>-->

              <td>
                {{ data.WSOut_Transp_CNPJ }}
              </td>
              <td>
                {{ data.WSOut_Transp_Email }}
              </td>
              <td class="text-end">
                {{ data.WSOut_MovCot_ID }}
              </td>

            </tr>

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 text-end">Quantidade Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="text-end"> {{ formatDecimal(0.00) }}</td>-->
            <!--            </tr>-->

            <!--            <tr>-->
            <!--              <td colspan="4">-->
            <!--                <h6 class="m-0 font-size-14  text-end">Peso Total Volumes:</h6>-->
            <!--              </td>-->
            <!--              <td class="font-size-14 text-end"> {{ formatDecimal(0.00) }}</td>-->
            <!--            </tr>-->

            </tbody>
          </table>
        </div>


        <!--        <div class="mb-3">-->
        <!--          <label for="obs">Observações do Pedido</label>-->
        <!--          <textarea-->
        <!--              id="obs"-->
        <!--              v-model="movData.obs"-->
        <!--              type="text"-->
        <!--              rows="3"-->
        <!--              class="form-control"-->
        <!--              placeholder="Observações do Pedido"/>-->
        <!--        </div>-->


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCotarFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalCotarFrete = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal size="xl"
             title="Cotação de Frete Interna"
             v-model="showModalCotarFreteInterno"
             centered hide-footer>
      <div class="col-md-12">

        <div class="row" v-if="loadingCotarFrete">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>

        <div class="table-responsive" v-if="cotaFreteInternoListData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Ações</th>
              <th scope="col">Transportador</th>
              <th scope="col" class="text-end">Frete R$</th>
              <th scope="col" class="text-end">Frete %</th>
              <th scope="col" class="text-end">Frete KG</th>


              <th scope="col" class="text-end">PrazoDias</th>

              <th scope="col">TranspCNPJ</th>
              <th scope="col">TranspEmail</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotaFreteInternoListData" :key="data.id">
              <td>

                <a href="javascript:void(0);"
                   v-b-tooltip.hover
                   class="action-icon text-info mx-2"
                   title="Escolher Transportadora">
                  <i class="mdi mdi-check-outline font-size-18"></i>
                </a>


              </td>

              <td>
                {{ data.transp_id }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal(data.WSOut_Frete_Val) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / movData.valorliq) * 100) }}
              </td>

              <td class="text-end">
                <i class="bx bxs-dollar-circle font-size-18 bx-fade-right text-success" v-if="data.menorvalor"></i>
                {{ formatDecimal((data.WSOut_Frete_Val / pesoAcotar) * 100) }}
              </td>

              <!--              <td>-->
              <!--                <div>-->
              <!--                  <h5 class="text-truncate font-size-14">-->
              <!--                    {{ formatDateTime(data.WSOut_DataH) }}-->
              <!--                  </h5>-->
              <!--                </div>-->
              <!--              </td>-->

              <td class="text-end">
                <i class="bx bxs-calendar font-size-18 bx-fade-right text-info" v-if="data.menorprazo"></i>
                {{ data.prazo }}
              </td>


              <td>
                {{ data.WSOut_Transp_CNPJ }}
              </td>
              <td>
                {{ data.WSOut_Transp_Email }}
              </td>


            </tr>


            </tbody>
          </table>
        </div>


<!--        <div class="text-end mt-5">-->
<!--          <b-button variant="light" @click="showModalCotarFrete = false">-->
<!--            <i class="bx bx-block font-size-16 align-middle me-2"></i>-->
<!--            Cancelar-->
<!--          </b-button>-->
<!--          <b-button type="submit" variant="success" class="ms-1" @click="showModalCotarFrete = false">-->
<!--            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>-->
<!--            Confirmar-->
<!--          </b-button>-->
<!--        </div>-->
      </div>

    </b-modal>


    <b-modal size="md" title="Dados para Cotação" v-model="showModalPesoManual" centered hide-footer>


      <div class="row">


        <div class="col-md-12">
          <div class="mb-3">
            <span>Seguimento de Frete</span>

            <multiselect id="segtofrete"
                         class="mt-2"
                         @search-change="pesqFreteCotaEmpr"
                         @select="escolheuFreteCota"
                         v-model="emprSegtoData.codigo"
                         placeholder="Pesquisar seguimento"
                         :options="dtListPesqFreteCota"
                         :searchable="true"
                         label="nome"
                         track-by="nome"
                         :style="submmitedPesoManual && !emprSegtoData.codigo ? 'border: 1px solid #f86c6b !important;' : ''"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="mx-4"></span>
                  </div>
                  <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                  <span class="mx-4"> </span>
                  <span class="mx-4"> </span>
                  <div class="align-items-end text-end align-content-end">{{
                      formatDateTime(slotProps.option.created_at)
                    }}
                  </div>
                </div>
              </template>
            </multiselect>
            <div v-if="submmitedPesoManual && !emprSegtoData.codigo">
              <span class="text-danger font-size-11">Campo Seguimento obrigatório, favor selecionar.</span>
            </div>

          </div>
        </div>

      </div>


      <div class="row text-center ">

        <div class="col-lg-12">
          <div class="mb-3">
            <label for="pesomanual">Peso Cotação</label>
            <div class="position-relative">
              <input
                  id="pesomanual"
                  v-model="movData.pesomanual"
                  type="number"
                  class="form-control"
                  :class="{'is-invalid': submmitedPesoManual && !movData.pesomanual }"/>
              <div v-if="submmitedPesoManual && !movData.pesomanual" class="invalid-feedback">
                <span>Campo peso obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>


        <div class="col-lg-12">
          <div class="mb-3">
            <label for="dimemanual">Dimensões Cotação (Mín: 0,0034)</label>
            <div class="position-relative">
              <input
                  id="dimemanual"
                  v-model="movData.dimemanual"
                  type="number"
                  class="form-control"
                  :min="0.0034"
                  :class="{'is-invalid': submmitedPesoManual && !movData.dimemanual }"/>
              <div v-if="submmitedPesoManual && !movData.dimemanual" class="invalid-feedback">
                <span>Campo dimensões obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPesoManual = false">
          <i class="bx bx-sync font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confPesoManual">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


    <b-modal title="Criar Novo Anexo (Comprovante)" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile"/>
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"
                    :class="{'is-invalid': submittedAnexo && !descranexo}"/>
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="xl" title="PLP Correios" v-model="showModalPLPCorreios" centered hide-footer>


      <div class="card-body">


        <div v-if="(exibirNovaPlp === true) && loadingMovPlp === false">

          <div>
            <div class="col-md-12">
              <div class="mb-3">
<!--                <label for="modalPLPCorreios">Criar Nova PLP</label>-->
                <label for="modalPLPCorreios">Criar Nova PLP para Pedido: <span class="text-black-50">{{ this.pedidoSelecionado }}</span></label>
              </div>
            </div>


            <div class="row">

              <div class="col-sm-3">
                <div class="mb-3">
                  <label for="formato">Formato Objeto</label>
                  <select
                      id="formato"
                      v-model="movPlpData.formato"
                      class="form-control"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.formato}">
                    <option value=1>Envelope</option>
                    <option value=2>Caixa / Pacote</option>
                    <option value=3>Rolo / Cilindro</option>
                  </select>
                  <div v-if="submittedMovPlp && !movPlpData.formato" class="invalid-feedback">
                    <span>Campo formato obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-sm-2">
                <div class="mb-3">
                  <label for="layprint">Layout Impressão</label>
                  <select
                      id="layprint"
                      v-model="movPlpData.layprint"
                      class="form-control">
                    <!--                    <option value=PADRAO>PADRAO</option>-->
                    <option value=LINEAR_100_150>LINEAR_100_150</option>
                    <option value=LINEAR_100_80>LINEAR_100_80</option>
                    <option value=LINEAR_A4>LINEAR_A4</option>
                    <option value=LINEAR_A>LINEAR_A</option>
                  </select>
                  <div v-if="submittedMovPlp && !movPlpData.formato" class="invalid-feedback">
                    <span>Campo formato obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>


              <div class="col-md-6">
                <div class="mb-3">
                  <span>Serviço</span>

                  <multiselect id="segtofrete"
                               class="mt-2"
                               @search-change="pesqCorreioServico"
                               v-model="movPlpData.servico"
                               placeholder="Pesquisar serviços"
                               :options="dtListPesqCorreioServico"
                               :searchable="true"
                               label="descricao"
                               track-by="descricao"
                               :style="submittedMovPlp && !movPlpData.servico ? 'border: 1px solid #f86c6b !important;' : ''"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                          <span class="text-info">
                            {{ slotProps.option.codigo }}
                          </span>
                          <span class="mx-4" >
                          </span>
                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                        <span class="mx-4"></span>
                        <span class="mx-4"></span>
                        <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                      </div>
                    </template>
                  </multiselect>
                  <div v-if="submittedMovPlp && !movPlpData.servico">
                    <span class="text-danger font-size-11">Campo Serviço obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>
<!--              <div class="col-sm-3">
                <div class="mb-3">
                  <label for="servico">Serviço</label>
                  <select
                      id="servico"
                      v-model="movPlpData.servico"
                      class="form-control"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.servico}">
                    <option value="04669">PAC Contrato Agência</option>
                    <option value="04162">Sedex Contrato Agência</option>
                    <option value="03328">PAC CONTR GRAND FORMATO</option>

                  </select>
                  <div v-if="submittedMovPlp && !movPlpData.servico" class="invalid-feedback">
                    <span>Campo serviço obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>-->

            </div>


            <div class="row">

              <div class="col-md-3">
                <label for="pesoinf">Peso (GR)</label>
                <div class="position-relative">
                  <input
                      id="pesoinf"
                      type="number"
                      v-model="movPlpData.pesoinf"
                      class="form-control text-end"
                      placeholder="Peso informado"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.pesoinf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.pesoinf" class="invalid-feedback">
                    <span>Campo peso obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>


              <div class="col-md-2">
                <label for="compinf">Comprimento (CM)</label>
                <div class="position-relative">
                  <input
                      id="compinf"
                      type="number"
                      v-model="movPlpData.compinf"
                      class="form-control text-end"
                      placeholder="Comprimento informado"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.compinf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.compinf" class="invalid-feedback">
                    <span>Campo comprimento obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>



              <div class="col-md-2">
                <label for="altuinf">Altura (CM)</label>
                <div class="position-relative">
                  <input
                      id="altuinf"
                      type="number"
                      v-model="movPlpData.altuinf"
                      class="form-control text-end"
                      placeholder="Altura informada"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.altuinf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.altuinf" class="invalid-feedback">
                    <span>Campo altura obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <label for="larginf">Largura (CM)</label>
                <div class="position-relative">
                  <input
                      id="larginf"
                      type="number"
                      v-model="movPlpData.larginf"
                      class="form-control text-end"
                      placeholder="Largura informada"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.larginf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.larginf" class="invalid-feedback">
                    <span>Campo largura obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>



              <div class="col-md-2">
                <label for="prevpost">Previsão Postagem</label>
                <div class="position-relative">
                  <input
                      id="prevpost"
                      type="date"
                      v-model="movPlpData.prevpost"
                      class="form-control text-end"
                      placeholder="Previsão Postagem"
                      @input="integerOnly"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.larginf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.larginf" class="invalid-feedback">
                    <span>Campo previsão postagem obrigatório, favor preencher.</span>
                  </div>


                </div>
              </div>

            </div>

<!--            <div class="row">
              <div class="col-md-3">
                <label for="compinf">Comprimento informado</label>
                <div class="position-relative">
                  <input
                      id="compinf"
                      type="number"
                      v-model="movPlpData.compinf"
                      class="form-control text-end"
                      placeholder="Comprimento informado"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.compinf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.compinf" class="invalid-feedback">
                    <span>Campo comprimento obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label for="pesoinf">Peso informado</label>
                <div class="position-relative">
                  <input
                      id="pesoinf"
                      type="number"
                      v-model="movPlpData.pesoinf"
                      class="form-control text-end"
                      placeholder="Peso informado"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.pesoinf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.pesoinf" class="invalid-feedback">
                    <span>Campo peso obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label for="altuinf">Altura informada</label>
                <div class="position-relative">
                  <input
                      id="altuinf"
                      type="number"
                      v-model="movPlpData.altuinf"
                      class="form-control text-end"
                      placeholder="Altura informada"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.altuinf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.altuinf" class="invalid-feedback">
                    <span>Campo altura obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <label for="larginf">Largura informada</label>
                <div class="position-relative">
                  <input
                      id="larginf"
                      type="number"
                      v-model="movPlpData.larginf"
                      class="form-control text-end"
                      placeholder="Largura informada"
                      :class="{'is-invalid': submittedMovPlp && !movPlpData.larginf}"/>
                  <div v-if="submittedMovPlp && !movPlpData.larginf" class="invalid-feedback">
                    <span>Campo largura obrigatório, favor preencher.</span>
                  </div>
                </div>
              </div>
            </div>-->

          </div>

        </div>


        <div class="row" v-if="loadingMovPlp">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>


        <div class="table-responsive mt-5" v-if="movPlpsData && !loadingMovPlp">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">ID Correios</th>
              <th scope="col" class="">Objeto</th>
              <th scope="col" class="text-end">Peso</th>
              <th scope="col">Status</th>
              <th scope="col">Pr.Postagem</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in movPlpsData" :key="data.id">
              <td>
                {{ data.id }}
              </td>

              <td>
                {{ data.correiosid }}
              </td>
              <td>
                {{ data.codobj }}
              </td>

              <td class="text-end">
                {{ formatDecimal(data.pesoinf) }}
              </td>
              <!--              <td>-->
              <!--                -->
              <!--                -->
              <!--                {{ data.descstatus }}-->
              <!--              </td>-->

              <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === '5' ? 'badge-soft-danger' : 'badge-soft-success'">
                {{ data.descstatus }}
              </span>
              </td>

              <td>
                {{ formatDate(data.prazopost) }}
              </td>
              <td class="text-end">
                {{ formatDateTime(data.created_at) }}
              </td>

              <td class="text-end">



                <a href="javascript:void(0);"
                   v-if="data.status !== '5'"
                   class="action-icon text-warning mx-2"
                   title="Solicitar Rótulo"
                   @click="solicitarRotulo(data)">
                  <i class="mdi mdi-printer font-size-18"></i>
                </a>

                <a href="javascript:void(0);"
                   v-if="data.status !== '5'"
                   class="action-icon text-danger mx-2"
                   title="Cancelar PLP"
                   @click="cancelarMovPlp(data.id)">
                  <i class="mdi mdi-trash-can font-size-18"></i>
                </a>

              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPLPCorreios = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confPLPCorreios" v-if="exibirNovaPlp">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Criar Nova PLP
          </b-button>
        </div>
      </div>

    </b-modal>



    <b-modal size="xl" title="Logística Reversa Correios" v-model="showModalLogRev" centered hide-footer>

      <div class="card-body">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">

              <b-tabs v-model="activeTabLogRev" pills justified content-class="p-3 text-muted">

                <b-tab active class="border-0">
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="fas fa-home"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Reversa</span>
                  </template>

                  <div class="row mt-2">

<!--                    <div class="col-sm-4">-->
<!--                      <div class="mb-3">-->
<!--                        <h5 class="font-size-14">Coleta Domiciliária</h5>-->
<!--                        <b-form-checkbox switch size="lg" value="S" unchecked-value="N" v-model="logistReverData.coledom">-->
<!--                          {{ logistReverData.coledom === 'S' ? 'Sim' : 'Não' }}-->
<!--                        </b-form-checkbox>-->
<!--                      </div>-->
<!--                    </div>-->

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <h5 class="font-size-14">Aviso de Recebimento</h5>
                        <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model="logistReverData.avirec">
                          {{ logistReverData.avirec === '1' ? 'Sim' : 'Não' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <h5 class="font-size-14">Notificar Remetente</h5>
                        <b-form-checkbox switch size="lg" value=1 unchecked-value=0 v-model="logistReverData.notifrem">
                          {{ logistReverData.notifrem === '1' ? 'Sim' : 'Não' }}
                        </b-form-checkbox>
                      </div>
                    </div>

                  </div>

                  <div class="row">

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="codserv">
                          <code class="highlighter-rouge">*</code>
                          Serviço
                        </label>
                        <select id="codserv" v-model="logistReverData.codserv" class="form-control"
                                :class="{'is-invalid': submittedLogRevTab1 && !logistReverData.codserv}">
                          <option value="03247">03247 - SEDEX</option>
                          <option value="03301">03301 - PAC</option>
                        </select>
                        <div v-if="submittedLogRevTab1 && !logistReverData.codserv" class="invalid-feedback">
                          <span>Campo serviço obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="tipo">
                          <code class="highlighter-rouge">*</code>
                          Tipo
                        </label>
                        <select id="tipo" v-model="logistReverData.tipo" class="form-control"
                                :class="{'is-invalid': submittedLogRevTab1 && !logistReverData.tipo}">
                          <option value="CA">CA - Coleta Domiciliar</option>
                          <option value="C">C - Coleta Domiciliária</option>
                          <option value="A">A - Autorização de Postagem</option>
                        </select>
                        <div v-if="submittedLogRevTab1 && !logistReverData.tipo" class="invalid-feedback">
                          <span>Campo tipo obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="prod1">
                          <code class="highlighter-rouge">*</code>
                          Identificação / Referência 1
                        </label>
                        <input id="prod1" v-model="logistReverData.prod1" type="text" class="form-control"
                               placeholder="Identificação / Referência 1" :class="{'is-invalid': submittedLogRevTab1 && !logistReverData.prod1}" />
                        <div v-if="submittedLogRevTab1 && !logistReverData.prod1" class="invalid-feedback">
                          <span>Campo Identificação / Referência 1 obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row">

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="prod2">Identificação / Referência 2</label>
                        <input id="prod2" v-model="logistReverData.prod2" type="text" class="form-control"
                               placeholder="Identificação / Referência 2" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="prod3">Identificação / Referência 3</label>
                        <input id="prod3" v-model="logistReverData.prod3" type="text" class="form-control"
                               placeholder="Identificação / Referência 3" />
                      </div>
                    </div>

                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="aglimcol" v-if="logistReverData.tipo === 'CA' || logistReverData.tipo === 'C'">
                          <code class="highlighter-rouge">*</code>Data de Coleta
                        </label>
                        <label for="aglimcol" v-else>
                          <code class="highlighter-rouge">*</code>Prazo de Postagem
                        </label>
                        <input id="aglimcol"
                               v-model="logistReverData.aglimcol"
                               type="date"
                               class="form-control"
                               placeholder="Prazo de Postagem" :class="{'is-invalid': submittedLogRevTab1 && !logistReverData.aglimcol}" />
                        <div v-if="submittedLogRevTab1 && !logistReverData.aglimcol" class="invalid-feedback">
                          <span>Campo Data de Coleta / Prazo de Postagem obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div class="row mt-2">
                    <div class="text-end">
                      <b-button variant="outline-success" class="ms-1" @click="confTab1LogRev">
                        Avançar
                        <i class="bx bx-right-arrow font-size-16 align-middle ms-2"></i>
                      </b-button>
                    </div>
                  </div>

                </b-tab>


                <b-tab>
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-user"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Remetente da Reversa</span>
                  </template>


                  <div class="row" v-if="loadingCnpjRemet">
                    <div class="col-12 text-center">
                      <b-spinner type="grow"
                                 class="m-6 mx-2"
                                 variant="secondary"
                                 role="status">
                      </b-spinner>
                      <b-spinner type="grow"
                                 class="m-6 mx-2"
                                 variant="secondary"
                                 role="status">
                      </b-spinner>
                      <b-spinner type="grow"
                                 class="m-6 mx-2"
                                 variant="secondary"
                                 role="status">
                      </b-spinner>
                    </div>
                  </div>

                  <div class="row" v-if="!loadingCnpjRemet">

                    <div class="col-md-3">
                      <label for="cnpj">
                        <code class="highlighter-rouge">*</code>
                        CPF / CNPJ
                      </label>
                      <div class="position-relative">
                        <input id="cnpj"
                               v-maska="logistReverData.remetcnpj && logistReverData.remetcnpj.length > 14 ? '##.###.###/####-##' : '###.###.###-##'"
                               type="text" v-model="logistReverData.remetcnpj" class="form-control" placeholder="CPF / CNPJ"
                               :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetcnpj}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetcnpj" class="invalid-feedback">
                          <span>Campo CPF / CNPJ obrigatório, favor preencher.</span>
                        </div>
                        <div class="chat-input-links" v-if="logistReverData.remetcnpj">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a @click="consultarCNPJRem" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                 title="Consultar CNPJ">
                                <i class="mdi mdi-cloud-search-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="remetnome">
                          <code class="highlighter-rouge">*</code>
                          Nome
                        </label>
                        <input id="remetnome"
                               v-model="logistReverData.remetnome"
                               type="text" class="form-control"
                               placeholder="Nome" :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetnome}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetnome" class="invalid-feedback">
                          <span>Campo Nome obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-3">
                      <label for="remetcep">CEP</label>
                      <div class="position-relative">
                        <input id="remetcep" v-maska="'##.###-###'" type="text" v-model="logistReverData.remetcep"
                               class="form-control" placeholder="CEP"
                               :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetcep}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetcep" class="invalid-feedback">
                          <span>Campo CEP obrigatório, favor preencher.</span>
                        </div>
                        <div class="chat-input-links" v-if="logistReverData.remetcep">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a @click="consultarCEPRem" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                 title="Consultar CEP">
                                <i class="mdi mdi-cloud-search-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="remetbairro">
                          <code class="highlighter-rouge">*</code>
                          Bairro
                        </label>
                        <input id="remetbairro" v-model="logistReverData.remetbairro" type="text" class="form-control"
                               placeholder="Bairro" :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetbairro}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetbairro" class="invalid-feedback">
                          <span>Campo Bairro obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="remetrua">
                          <code class="highlighter-rouge">*</code>
                          Logradouro
                        </label>
                        <input id="remetrua" v-model="logistReverData.remetrua" type="text" class="form-control"
                               placeholder="Logradouro" :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetrua}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetrua" class="invalid-feedback">
                          <span>Campo Logradouro obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="remetnum">
                          <code class="highlighter-rouge">*</code>
                          Número
                        </label>
                        <input id="remetnum" v-model="logistReverData.remetnum" type="text" class="form-control"
                               placeholder="Número" :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetnum}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetnum" class="invalid-feedback">
                          <span>Campo Número obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="remetcompl">
                          Complemento
                        </label>
                        <input id="remetcompl" v-model="logistReverData.remetcompl" type="text" class="form-control"
                               placeholder="Complemento" />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="remetcidade">
                          <code class="highlighter-rouge">*</code>
                          Cidade
                        </label>
                        <input id="remetcidade" v-model="logistReverData.remetcidade" type="text" class="form-control"
                               placeholder="Cidade" :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetcidade}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetcidade" class="invalid-feedback">
                          <span>Campo Cidade obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="remetestado">
                          <code class="highlighter-rouge">*</code>
                          UF
                        </label>
                        <input id="remetestado" v-model="logistReverData.remetestado" type="text" class="form-control"
                               placeholder="UF" :class="{'is-invalid': submittedLogRevTab2 && !logistReverData.remetestado}" />
                        <div v-if="submittedLogRevTab2 && !logistReverData.remetestado" class="invalid-feedback">
                          <span>Campo UF obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-2">
                      <div class="mb-3">
                        <label for="remetddd">
                          DDD
                        </label>
                        <input id="remetddd" v-model="logistReverData.remetddd" type="text" class="form-control"
                               placeholder="DDD" />
                      </div>
                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="remettel">
                          Telefone
                        </label>
                        <input id="remettel" v-model="logistReverData.remettel" type="text" class="form-control"
                               placeholder="Telefone" />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="remetemail">
                          E-mail
                        </label>
                        <input id="remetemail" v-model="logistReverData.remetmail" type="text" class="form-control"
                               placeholder="E-mail" />
                      </div>
                    </div>

                  </div>

                  <div class="row mt-2">
                    <div class="text-end">

                      <b-button variant="outline-secondary" class="ms-1" @click="activeTabLogRev = 0">
                        <i class="bx bx-left-arrow font-size-16 align-middle me-2"></i>
                        Voltar
                      </b-button>

                      <b-button variant="outline-success" class="ms-1" @click="confTab2LogRev">
                        Avançar
                        <i class="bx bx-right-arrow font-size-16 align-middle ms-2"></i>
                      </b-button>

                    </div>
                  </div>

                </b-tab>


                <b-tab>
                  <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="far fa-envelope"></i>
                  </span>
                    <span class="d-none d-sm-inline-block">Destinatário da Reversa</span>
                  </template>


                  <div class="row" v-if="loadingCnpjDest">
                    <div class="col-12 text-center">
                      <b-spinner type="grow"
                                 class="m-6 mx-2"
                                 variant="secondary"
                                 role="status">
                      </b-spinner>
                      <b-spinner type="grow"
                                 class="m-6 mx-2"
                                 variant="secondary"
                                 role="status">
                      </b-spinner>
                      <b-spinner type="grow"
                                 class="m-6 mx-2"
                                 variant="secondary"
                                 role="status">
                      </b-spinner>
                    </div>
                  </div>


                  <div class="row" v-if="!loadingCnpjDest">

                    <div class="col-md-3">
                      <label for="cnpj">
                        <code class="highlighter-rouge">*</code>
                        CPF / CNPJ
                      </label>
                      <div class="position-relative">
                        <input id="cnpj"
                               v-maska="logistReverData.destcnpj && logistReverData.destcnpj.length > 14 ? '##.###.###/####-##' : '###.###.###-##'"
                               type="text" v-model="logistReverData.destcnpj" class="form-control" placeholder="CPF / CNPJ"
                               :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destcnpj}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destcnpj" class="invalid-feedback">
                          <span>Campo CPF / CNPJ obrigatório, favor preencher.</span>
                        </div>
                        <div class="chat-input-links" v-if="logistReverData.destcnpj">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a @click="consultarCNPJDest" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                 title="Consultar CNPJ">
                                <i class="mdi mdi-cloud-search-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="destnome">
                          <code class="highlighter-rouge">*</code>
                          Nome
                        </label>
                        <input id="destnome"
                               v-model="logistReverData.destnome"
                               type="text" class="form-control"
                               placeholder="Nome" :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destnome}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destnome" class="invalid-feedback">
                          <span>Campo Nome obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-3">
                      <label for="destcep">CEP</label>
                      <div class="position-relative">
                        <input id="destcep" v-maska="'##.###-###'" type="text" v-model="logistReverData.destcep"
                               class="form-control" placeholder="CEP"
                               :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destcep}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destcep" class="invalid-feedback">
                          <span>Campo CEP obrigatório, favor preencher.</span>
                        </div>
                        <div class="chat-input-links" v-if="logistReverData.destcep">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a @click="consultarCEPDest" href="javascript: void(0);" v-b-tooltip.hover placement="top"
                                 title="Consultar CEP">
                                <i class="mdi mdi-cloud-search-outline"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="destbairro">
                          <code class="highlighter-rouge">*</code>
                          Bairro
                        </label>
                        <input id="destbairro" v-model="logistReverData.destbairro" type="text" class="form-control"
                               placeholder="Bairro" :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destbairro}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destbairro" class="invalid-feedback">
                          <span>Campo Bairro obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="destrua">
                          <code class="highlighter-rouge">*</code>
                          Logradouro
                        </label>
                        <input id="destrua" v-model="logistReverData.destrua" type="text" class="form-control"
                               placeholder="Logradouro" :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destrua}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destrua" class="invalid-feedback">
                          <span>Campo Logradouro obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="destnum">
                          <code class="highlighter-rouge">*</code>
                          Número
                        </label>
                        <input id="destnum" v-model="logistReverData.destnum" type="text" class="form-control"
                               placeholder="Número" :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destnum}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destnum" class="invalid-feedback">
                          <span>Campo Número obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="destcompl">
                          Complemento
                        </label>
                        <input id="destcompl" v-model="logistReverData.destcompl" type="text" class="form-control"
                               placeholder="Complemento" />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="destcidade">
                          <code class="highlighter-rouge">*</code>
                          Cidade
                        </label>
                        <input id="destcidade" v-model="logistReverData.destcidade" type="text" class="form-control"
                               placeholder="Cidade" :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destcidade}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destcidade" class="invalid-feedback">
                          <span>Campo Cidade obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-sm-3">
                      <div class="mb-3">
                        <label for="destestado">
                          <code class="highlighter-rouge">*</code>
                          UF
                        </label>
                        <input id="destestado" v-model="logistReverData.destestado" type="text" class="form-control"
                               placeholder="UF" :class="{'is-invalid': submittedLogRevTab3 && !logistReverData.destestado}" />
                        <div v-if="submittedLogRevTab3 && !logistReverData.destestado" class="invalid-feedback">
                          <span>Campo UF obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>


                    <div class="col-sm-2">
                      <div class="mb-3">
                        <label for="destddd">
                          DDD
                        </label>
                        <input id="destddd" v-model="logistReverData.destddd" type="text" class="form-control"
                               placeholder="DDD" />
                      </div>
                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3">
                        <label for="desttel">
                          Telefone
                        </label>
                        <input id="desttel" v-model="logistReverData.desttel" type="text" class="form-control"
                               placeholder="Telefone" />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="mb-3">
                        <label for="destemail">
                          E-mail
                        </label>
                        <input id="destemail" v-model="logistReverData.destmail" type="text" class="form-control"
                               placeholder="E-mail" />
                      </div>
                    </div>

                  </div>


                  <div class="row mt-2">
                    <div class="text-end">

                      <b-button variant="outline-secondary" class="ms-1" @click="activeTabLogRev = 1">
                        <i class="bx bx-left-arrow font-size-16 align-middle me-2"></i>
                        Voltar
                      </b-button>

                      <b-button variant="outline-success" class="ms-1" @click="confTab3LogRev">
                        Confirmar
                        <i class="bx bx-check-double font-size-16 align-middle ms-2"></i>
                      </b-button>

                    </div>
                  </div>

                </b-tab>


              </b-tabs>
            </div>
          </div>
        </div>

      </div>

    </b-modal>





    <b-modal title="Nova Previsão Entrega" v-model="showModalPrevEntr" centered hide-footer>
      <div>


        <div class="col-md-12">
          <div class="mb-3">
            <label for="dtpreventrep">Data Previsão Reprogramada</label>
            <input
                id="dtpreventrep"
                v-model="movData.dtpreventrep"
                type="date"
                class="form-control"
                placeholder="Data Previsão Reprogramada"
                :class="{'is-invalid': submittedPrevEntr && !movData.dtpreventrep,}"/>
            <div v-if="submittedPrevEntr && !movData.dtpreventrep"
                 class="invalid-feedback">
              <span >Campo data obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPrevEntr = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confProvEntr">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


  </Layout>
</template>

<style>

</style>

